<template>
<div v-resize="onResize">
  <v-card v-scroll="onScroll">
    <v-card-title class="pa-0 pr-1">
      <v-row>
        <v-col cols="6" lg="2" md="3" sm="3" class="pl-0 pr-0 pb-0">
          <template>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }" >
                <v-btn color="primary" class="ml-4" dark v-bind="attrs" v-on="on">
                  {{ $t('message.tickets.actions') }}
                </v-btn>
              </template>
              <v-list>
                <template v-if="orderModel.type !== 'offer' && orderModel.state !== 'for_production'">
                  <v-list-item @click="approveMaterials(true)">
                    <v-list-item-title>{{ $t('message.order.approveSelected') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="approveMaterials(false)">
                    <v-list-item-title>{{ $t('message.order.reverseApproval') }}</v-list-item-title>
                  </v-list-item>
                </template>
                <template v-if="orderModel.type === 'offer' && orderModel.state === 'accepted' && canCreateOrder">
                  <v-list-item @click="createOrderHandler()" :disabled="!canCreateOrder">
                    <v-list-item-title>{{ $t('message.order.createOrder') }}</v-list-item-title>
                  </v-list-item>
                </template>
                <v-list-item @click="removeRowHandler()">
                  <v-list-item-title>{{ $t('message.common.delete') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-col>
        <v-col cols="6" lg="1" md="2" sm="2" class="pl-0 pr-0 pb-0">
          <v-btn color="primary" class="ml-2" @click="checkIfCreateRestOrder" v-if="orderModel.type !== 'offer' && orderModel.state === 'to_invoice'">{{ $t('message.customer.invoice') }}</v-btn>
        </v-col>
        <!-- <v-col cols="6" sm="2" class="pl-0 pr-0 pb-0">
          <v-btn color="success" v-if="(orderModel.type === 'offer' && orderModel.state !== 'create_order') || ((orderModel.type === 'order' || orderModel.type === 'rest_order') && !isNothingPicked)" @click="checkForImport" class="ml-2"
            >{{ $t('message.orders.archicad') }}</v-btn>
        </v-col> -->
        <v-col cols="6" lg="1" md="3" sm="3" class="pl-0 pr-0 pb-0">
          <v-menu offset-y v-if="orderModel.id">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="info" class="ml-3" v-on="on" dark :loading="actionLoading" v-bind="attrs">
                {{ $t('message.mailConfiguration.action') }}
              </v-btn>
            </template>
            <v-list>
              <template v-for="(item, index) in mainActions">
                <v-list-item v-if="item.value === 'pick' || item.value === 'export' ? item.show : true" :key="index" @click="mainActionHandler(item.value)">
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="6" lg="1" md="2" sm="2" class="pl-0 pr-1 pb-0">
          <v-select hide-details dense outlined v-model="zonesFilter" @change="zoneFilterHandler()" multiple :items="listOfZones" item-text="text" item-value="value" :label="$t('message.orders.zone')">
            <template v-slot:selection="{ item, index }">
              <span style="font-size: 14px;" v-if="index === 0">{{ item.text }}</span>
              <span v-if="index === 1" class="grey--text" style="font-size: 11px;">
                (+{{ zonesFilter.length - 1 }}) {{ $t('message.common.others') }}
              </span>
            </template>
          </v-select>
          <p class="caption mb-0">{{ $t('message.orders.totalRows') }} : {{ totalMaterialRows }}</p>
        </v-col>
        <v-col cols="6" lg="1" md="2" sm="2" class="pl-0 pr-0 pb-0">
          <v-select hide-details dense outlined v-model="productFilter" @change="filterItemsByStatus(true)" :items="productFilterItems" item-text="text" item-value="value" :label="$t('message.layout.products')"></v-select>
        </v-col>
        <v-col cols="6" lg="4" md="10" sm="10" class="pl-0 pr-0 pb-0">
          <v-row class="pa-0">
            <v-col cols="5" class="pa-0">
              <v-row class="ml-1 mr-1">
                <v-col cols="6" sm="7" lg="6" class="body-2 pa-0 pr-0 text-right">{{ $t('message.order.totalCost') }}:</v-col>
                <v-col cols="6" sm="5" lg="6" class="body-2 pa-0 pr-0 text-right">{{ grandCostTotal | replaceDotWithComma }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="7" class="pa-0">
              <v-row class="ml-1 mr-1">
                <v-col cols="6" sm="7" lg="6" class="body-2 pa-0 pr-0 text-right">{{ $t('message.orders.totalExVat') }}:</v-col>
                <v-col cols="6" sm="5" lg="6" class="body-2 pa-0 pr-5 text-right">{{ grandTotal | replaceDotWithComma }}</v-col>
              </v-row>
              <v-row class="ml-1 mr-1 mt-1">
                <v-col cols="6" sm="7" lg="6" class="body-2 pa-0 pr-0 text-right">{{ $t('message.common.total') }} DG (%):</v-col>
                <v-col cols="6" sm="5" lg="6" class="body-2 pa-0 pr-5 text-right">{{ totalDG | replaceDotWithComma }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6" lg="1" md="2" sm="2" class="pl-0 pb-0 text-right">
          <v-select hide-details dense outlined v-model="orderModel.invoicecurrencyid" @change="recalculateExchangeRate(orderModel.invoicecurrencyid)"
            :items="listOfCurrencyList" :disabled="editDisabled || isInvoiced" item-text="name" item-value="id" :label="$t('message.product.currency')"></v-select>
        </v-col>
        <v-col cols="6" lg="1" md="1" sm="1" class="pl-0 pb-0 text-right">
          <v-btn fab x-small color="primary" v-if="showScrollToBottom" @click="goToBottom"><v-icon>mdi-chevron-down</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-1 mt-0 material-table">
      <v-progress-circular rounded v-if="loadingProducts" :size="70" class="mt-0 mb-1 material-loading" indeterminate color="primary"></v-progress-circular>
      <v-form ref="materialForm">
        <v-simple-table dense class="bordered--table materials" width="100%">
          <template v-slot:default>
            <thead>
              <tr>
                <th width="1%" class="material-checkbox">
                  <v-checkbox v-if="!isOffer" dense hide-details v-model="isAllSelected" @change="selectToBeApproved" class="ma-0 mr-2 pa-0" color="primary" small></v-checkbox>
                </th>
                <th width="1%">
                  <!-- <v-btn icon small @click="toggleAllPackages">
                    <v-icon v-if="!isAllExpand">mdi-arrow-up-drop-circle-outline</v-icon>
                    <v-icon v-else>mdi-arrow-down-drop-circle-outline</v-icon>
                  </v-btn> -->
                </th>
                <th width="4%"></th>
                <th width="3%">{{ $t('message.orders.zone') }}</th>
                <template v-if="!isOffer">
                  <th width="1%">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">S</span>
                      </template>
                      <span>{{ $t('message.order.notStockItem') }}</span>
                    </v-tooltip>
                  </th>
                </template>
                <th :width="isOffer ? '13%' : '11%'" class="pa-0" @click="showProductSearch = true" style="cursor: pointer;">
                  <div v-if="!showProductSearch">
                    {{ $t('message.orders.productNo') }}
                    <v-icon small>mdi-magnify</v-icon>
                  </div>
                  <v-text-field
                    v-else
                    v-model="productSearchText"
                    @input="filterByProductNumber"
                    @blur="handleProductSearchBlur"
                    dense
                    outlined
                    hide-details
                    clearable
                    :placeholder="$t('message.orders.productNo')"
                    @click.stop
                    ref="productSearchField"
                  ></v-text-field>
                </th>
                <th width="17%" class="pa-0" @click="showProductNameSearch = true" style="cursor: pointer;">
                  <div v-if="!showProductNameSearch">
                    {{ $t('message.mailConfiguration.name') }}
                    <v-icon small>mdi-magnify</v-icon>
                  </div>
                  <v-text-field
                    v-else
                    v-model="productNameSearchText"
                    @input="filterByProductName"
                    @blur="handleProductNameSearchBlur"
                    dense
                    outlined
                    hide-details
                    clearable
                    :placeholder="$t('message.mailConfiguration.name')"
                    @click.stop
                    ref="productNameSearchField"
                  ></v-text-field>
                </th>
                <th width="4%">{{ $t('message.whOrder.orderQty') }}</th>
                <template v-if="!isOffer">
                  <th width="5%">{{ $t('message.orders.pQty') }}</th>
                  <th width="7%">
                    {{ $t('message.layout.warehouse') }}
                    <v-progress-circular v-if="loadingWarehouse" indeterminate color="primary"></v-progress-circular>
                  </th>
                  <th width="7%">
                    {{ $t('message.stock.location') }}
                    <v-progress-circular v-if="loadingLocations" indeterminate color="primary"></v-progress-circular>
                  </th>
                </template>
                <th width="4%">{{ $t('message.orders.invoiceQty') }}</th>
                <th width="5%">{{ $t('message.order.purchase') }}</th>
                <th width="5%">{{ $t('message.document.cost') }}</th>
                <th width="5%">{{ $t('message.orders.price') }}</th>
                <th width="4%" class="text-center">
                  {{ `${$t('message.product.discount')} %` }}
                  <v-icon small @click="openDiscountDialog">mdi-pencil</v-icon>
                </th>
                <th width="4%">{{ `${$t('message.customer.vatValue')} %` }}</th>
                <template v-if="isOffer">
                  <th width="5%">{{ $t('message.product.available') }}</th>
                </template>
                <th width="5%">
                  {{ $t('message.orders.totalExVat') }}
                </th>
                <th width="7%">
                  {{ $t('message.order.batchNo') }}
                  <v-progress-circular v-if="loadingBatches" indeterminate color="primary"></v-progress-circular>
                </th>
                <th width="8%">DG%</th>
                <th width="1%"></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in listOfMaterials">
                <template v-if="item.zonefilter">
                  <template v-if="!item.orderindex">
                    <tr :key="`material-${item.id || index}-${item.productid || 'new'}`" v-if="item.is_show && item.content_show" class="row-package-bg"
                      @click="enableEditRow($event, index)"
                      @mouseenter="onRowMouseEnter(index)"
                      @mouseleave="onRowMouseLeave()"
                      draggable='true' @dragstart='dragStart($event, item)' @mousedown="mouseDown" @mouseup="mouseReleased" @dragenter="dragEnter($event, item)" @dragleave="dragLeave($event, item)" @dragend="dragEnd">
                      <td class="pa-0" @click.stop="checkEditable($event, index)">
                        <template v-if="item.id">
                          <template v-if="!item.packageid">
                            <v-checkbox dense v-model="item.isapprovedWrapper" @change="checkAllCheckbox()" hide-details class="ma-0" color="primary"></v-checkbox>
                          </template>
                          <!-- <template v-if="(!item.ispackage && item.product_type === 'product' ? (item.olditem.qty ? item.olditem.locationid : false) : item.olditem.qty) && !item.packageid && (item.ispackage ? item.pickedallqties : true)">
                            <v-checkbox dense v-model="item.isapprovedWrapper" @change="item.isapproved = item.isapprovedWrapper" hide-details class="ma-0" color="primary"></v-checkbox>
                          </template> -->
                        </template>
                      </td>
                      <td class="pa-0" @click.stop="checkEditable($event, index)">
                        <v-btn icon small v-if="item.isproduction ? (orderModel.isproductionorder && item.ispackage) : item.ispackage" @click="toggleContentProducts(item.id, index, item.toggle_show)">
                          <v-icon v-if="item.toggle_show">mdi-arrow-up-drop-circle-outline</v-icon>
                          <v-icon v-else>mdi-arrow-down-drop-circle-outline</v-icon>
                        </v-btn>
                      </td>
                      <td class="pa-0" @click.stop="checkEditable($event, index)">
                        <v-row>
                          <v-col cols="6" class="pa-0" v-if="!isOffer">
                            <template v-if="item.olditem.isapproved">
                              <v-icon style="font-size: 20px;">mdi-check-circle-outline</v-icon>
                            </template>
                          </v-col>
                          <v-col cols="6" class="pa-0" :class="isOffer ? 'ml-3' : ''">
                            <template v-if="hoveredRowIndex === index && (item.isproduction ? (!orderModel.isproductionorder || !item.ispackage) : !item.ispackage) && item.productid && orderModel.state !== 'invoiced' && orderModel.state !== 'create_order'">
                              <v-icon style="font-size: 20px;" @click="addNewProductAfterRow(item, index)">mdi-plus-circle-outline</v-icon>
                            </template>
                          </v-col>
                        </v-row>
                      </td>
                      <td class="pa-0" @click.prevent="checkEditable($event, index)">
                        <span class="pa-1" v-if="!item.isedit && item.productid">{{ item.zone }}</span>
                        <template v-else>
                          <v-text-field v-if="!item.packageid && !item.mainpackageid" :readonly="editDisabled || item.olditem.isapproved"
                          @change="changeThePositionOfRow(index)"
                          v-model="item.zone" outlined dense hide-details></v-text-field>
                        </template>
                      </td>
                      <template v-if="!isOffer">
                        <td class="pa-0 text-center" @click.prevent="checkEditable($event, index)">
                          <template v-if="item.productid && isIncludeInPurchaseOrder(item)">
                            <v-icon size="19" v-if="!item.isedit && !item.includeonpurchaseorder">mdi-checkbox-blank-outline</v-icon>
                            <v-checkbox v-else-if="item.isedit" dense :disabled="!!item.olditem.supplierorderitemid || !item.product_stockitem" v-model="item.includeonpurchaseorder" hide-details class="ma-0" color="primary"></v-checkbox>
                            <v-icon size="19" v-else-if="!item.isedit && item.includeonpurchaseorder" color="primary">mdi-checkbox-marked</v-icon>
                          </template>
                        </td>
                      </template>
                      <td class="pa-0" @click.prevent="checkEditable($event, index)" :class="['pl-0', item.product_stockitem ? 'row-stock-item-bg' : 'row-non-stock-item-bg']">
                        <template v-if="!item.isedit">
                          <span v-for="icon in item.paddingindex" :key="icon">
                            -
                          </span>
                        </template>
                        <template v-if="!item.isedit && item.productid">
                          <span class="pa-1">{{ item.number }}</span>
                        </template>
                        <template v-else>
                          <template v-if="item.id || item.from_package">
                            <span class="pa-1">{{ item.number }}</span>
                            <!-- <v-text-field :readonly="editDisabled || item.olditem.isapproved" v-model="item.number" outlined dense hide-details></v-text-field> -->
                          </template>
                          <v-autocomplete v-else item-text="productName" v-model="item.product" :disabled="orderModel.state === 'invoiced' || orderModel.state === 'create_order'" item-value="id"
                            :ref="`searchInput_${index}`" :items="item.products" dense
                            @change="addNewProductHandler(item.product, index)"
                            @keyup="$event.keyCode !== 13 ? loadProducts(`searchInput_${index}`, $event, index) : ''" autocomplete="off"
                            outlined hide-details>
                              <template slot="selection" slot-scope="{ item }">
                                {{ item.number }}
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.productName }}</v-list-item-title>
                                </v-list-item-content>
                              </template>
                          </v-autocomplete>
                        </template>
                      </td>
                      <td class="pa-0" @click.prevent="checkEditable($event, index)" :class="item.product_stockitem ? 'row-stock-item-bg' : 'row-non-stock-item-bg'">
                        <template v-if="!item.isedit && item.productid">
                          <span class="pa-1">{{ item.producttext }}</span>
                        </template>
                        <template v-else>
                          <v-text-field :readonly="editDisabled || item.olditem.isapproved" :rules="item.productid ? $_maxCharValidation(150) : []" v-model="item.producttext" @change="changesMade" outlined dense hide-details></v-text-field>
                        </template>
                      </td>
                      <td class="pa-0 text-right" @click.prevent="checkEditable($event, index)">
                        <template v-if="!item.isinformation">
                          <template v-if="!item.isedit">
                            <span class="pa-1">{{ item.qty }}</span>
                          </template>
                          <template v-else>
                            <v-text-field :style="{
                                'background-color': item.qtyTrue ? '#ffc0c0' : '#00800026',
                              }" class="text-right-align" :ref="`qtyInput_${index}`" dense outlined :rules="item.productid ? [...$_requiredValidation, ...$_norwegianNumberMinusValidation] : []" hide-details
                                @keydown.enter="focusToNextNewProductRow(-1, false, index)"
                                @keydown.tab="focusToNextNewProductRow(-1, false, index)"
                                @change="onQtyChange(index, item)"
                              :readonly="editDisabled || item.olditem.isapproved" v-model="item.qty"></v-text-field>
                          </template>
                        </template>
                      </td>
                      <template v-if="!isOffer">
                        <td class="pa-0 text-right" @click.prevent="checkEditable($event, index)">
                          <template v-if="!item.isinformation">
                            <template v-if="!item.isedit">
                              <span class="pa-1">{{ item.pickedqty || '' }}</span>
                            </template>
                            <template v-else>
                              <template v-if="(item.isproduction ? (!orderModel.isproductionorder || !item.ispackage) : !item.ispackage) && item.product_type === 'product' && !item.product_notinventoryitem">
                                <template v-if="item.olditem.isapproved || item.olditem.pickedqty">
                                  <span class="pa-1">{{ item.pickedqty }}</span>
                                </template>
                                <v-text-field class="text-right-align" v-else dense outlined hide-details
                                  :readonly="editDisabled || isOffer || item.olditem.isapproved" v-model="item.pickedqty"
                                  @keyup="!item.olditem.pickedqty ? validateQty(index) : checkPickedQty(index)"
                                  :rules="item.warehouseid ? [...$_requiredValidation, ...$_norwegianNumberMinusValidation] : []"
                                  @change="setInvoiceQtyAndWarehouseRef(index)"></v-text-field>
                              </template>
                              <template v-else>
                                <template v-if="item.olditem.isapproved || item.olditem.pickedqty">
                                  <span class="pa-1">{{ item.pickedqty }}</span>
                                </template>
                              </template>
                            </template>
                          </template>
                        </td>
                        <td class="pa-0" width="8%" @click.prevent="checkEditable($event, index)"
                          style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 0px;">
                          <template v-if="!item.isinformation">
                            <template v-if="!item.isedit">
                              <span class="pa-1">{{ item.warehouse_name }}</span>
                            </template>
                            <template v-else>
                              <template>
                                <template v-if="(item.isproduction ? (!orderModel.isproductionorder || !item.ispackage) : !item.ispackage) && item.product_type === 'product' && !item.product_notinventoryitem">
                                  <template v-if="item.olditem.warehouseid && item.olditem.pickedqty">
                                    <span class="pa-1">{{ item.warehouse_name }}</span>
                                  </template>
                                  <v-autocomplete :class="isOrder ? `custom_prepend_icon ${item.warehouseOutOfStock ? 'out_of_stock' : ''}` : ''" @click:prepend="isOrder ? showAvailableDialog(item.productid) : null" :prepend-icon="isOrder ? 'mdi-information' : ''" autocomplete="off" v-else :readonly="editDisabled || isOffer || item.olditem.isapproved"
                                    v-model="item.warehouseid" :items="item.warehouses" item-text="warehouse_name" item-value="warehouse_id"
                                    hide-details full-width outlined dense @change="checkIfCCSheetIsOpen(index)" :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                                </template>
                              </template>
                            </template>
                          </template>
                        </td>
                        <td class="pa-0" @click.prevent="checkEditable($event, index)">
                          <template v-if="!item.isinformation">
                            <template v-if="!item.isedit">
                              <span class="pa-1">{{ item.warehouselocation_name }}</span>
                              <template v-if="item.olditem.locationid && item.olditem.pickedqty && !item.olditem.isapproved">
                                <v-icon @click.stop="undoPicking(item)" size="20" class="margin-2px float-right">mdi-rotate-left</v-icon>
                              </template>
                            </template>
                            <template v-else>
                              <template v-if="(item.isproduction ? (!orderModel.isproductionorder || !item.ispackage) : !item.ispackage) && item.product_type === 'product' && !item.product_notinventoryitem">
                                <template v-if="item.olditem.locationid && item.olditem.pickedqty">
                                  <span class="pa-1">{{ item.warehouselocation_name }}</span>
                                  <v-icon v-if="!item.olditem.isapproved" @click.stop="undoPicking(item)" size="20" class="margin-2px float-right">mdi-rotate-left</v-icon>
                                </template>
                                <v-autocomplete autocomplete="off" v-else :readonly="editDisabled || isOffer || item.olditem.isapproved"
                                  v-model="item.locationid" :items="item.locations" item-text="location_name" item-value="id"
                                  :rules="item.product_type === 'product' && !item.product_notinventoryitem ? (item.pickedqty ? $_requiredValidation : []) : []"
                                  hide-details full-width outlined dense @change="getListOfBatchNumbers(index)" :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                              </template>
                            </template>
                          </template>
                        </td>
                      </template>
                      <td class="pa-0 text-right" @click.prevent="checkEditable($event, index)">
                        <template v-if="!item.isinformation">
                          <template v-if="!item.isedit">
                            <span class="pa-1">{{ item.invoiceqty }}</span>
                          </template>
                          <template v-else>
                            <template v-if="orderModel.type === 'offer'">
                              <span class="pa-1">{{ item.invoiceqty }}</span>
                            </template>
                            <template v-else>
                              <template v-if="!item.isapproved">
                                <span class="pa-1">{{ item.invoiceqty }}</span>
                              </template>
                              <template v-else>
                                <v-text-field dense outlined hide-details class="text-right-align" :readonly="editDisabled || item.olditem.isapproved" @change="calculateDGValue(index, true)" v-model="item.invoiceqty"></v-text-field>
                              </template>
                            </template>
                          </template>
                        </template>
                      </td>
                      <td class="pa-0 text-right" @click.prevent="checkEditable($event, index)">
                        <template v-if="!item.isinformation">
                          <template v-if="!item.isedit">
                            <span class="pa-1">{{ item.purchaseprice }}</span>
                          </template>
                          <template v-else>
                            <v-text-field class="text-right-align" :rules="item.purchaseprice ? $_norwegianNumberValidation : []"
                            :readonly="editDisabled || item.olditem.isapproved || (((item.isproduction ? orderModel.isproductionorder && item.ispackage : item.ispackage) || !!item.packageid) && !item.isopenstructure)" v-model="item.purchaseprice" outlined dense hide-details></v-text-field>
                          </template>
                        </template>
                      </td>
                      <td class="pa-0 text-right" @click.prevent="checkEditable($event, index)">
                        <template v-if="!item.isinformation">
                          <template v-if="!item.isedit">
                            <span class="pa-1">{{ item.costprice }}</span>
                          </template>
                          <template v-else>
                            <v-text-field class="text-right-align" :rules="item.costprice ? $_norwegianNumberValidation : []"
                            :readonly="(((item.isproduction ? orderModel.isproductionorder && item.ispackage : item.ispackage) || !!item.packageid) && !item.isopenstructure)" @change="calculatePackagePrices(index, item, 'cost')" v-model="item.costprice" outlined dense hide-details></v-text-field>
                          </template>
                        </template>
                      </td>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <td v-bind="attrs" v-on="item.ispriceiscrepency ? on : null" class="pa-0 text-right" @click.prevent="checkEditable($event, index)" :style="{ background: item.ispriceiscrepency ? '#ff00003d' : '' }">
                            <template v-if="!item.isinformation">
                              <template v-if="!item.isedit">
                                <span class="pa-1">{{ item.price }}</span>
                              </template>
                              <template v-else>
                                <v-text-field class="text-right-align" :rules="item.price ? $_norwegianNumberValidation : []"
                                  :readonly="editDisabled || item.olditem.isapproved || (!!item.packageid && !item.isopenstructure)" @change="calculatePackagePrices(index, item, 'price')" v-model="item.price" outlined dense hide-details></v-text-field>
                              </template>
                            </template>
                          </td>
                        </template>
                        <span>{{ item.ispriceiscrepency ? `${$t('message.order.productPrice')}: ${item.product_salesprice}` : '' }}</span>
                      </v-tooltip>
                      <td class="pa-0 text-right" @click.prevent="checkEditable($event, index)">
                        <template v-if="!item.isinformation">
                          <template v-if="!item.isedit">
                            <span class="pa-1">{{ item.discount }}</span>
                          </template>
                          <template v-else>
                            <v-text-field class="text-right-align" :readonly="editDisabled || item.olditem.isapproved || (((item.isproduction ? orderModel.isproductionorder && item.ispackage : item.ispackage) || !!item.packageid) && !item.isopenstructure)" @change="calculatePackagePrices(index, item, 'discount')" v-model="item.discount" outlined dense hide-details></v-text-field>
                          </template>
                        </template>
                      </td>
                      <td class="pa-0 text-right" @click.prevent="checkEditable($event, index)">
                        <template v-if="!item.isinformation">
                          <template v-if="!item.isedit">
                            <span class="pa-1">{{ item.vat }}{{ item.vat ? '%' : '' }}</span>
                          </template>
                          <template v-else>
                            <v-select v-model="item.vat" :readonly="editDisabled || item.olditem.isapproved" outlined dense class="text-right-align"
                              :item-text="item.text" item-value="value" hide-details :items="listOfVAT"></v-select>
                          </template>
                        </template>
                      </td>
                      <template v-if="isOffer">
                        <td class="pa-0 text-center">
                          <template v-if="!item.isinformation">
                            <a style="text-decoration: underline" @click="showAvailableDialog(item.productid)">{{ item.available | replaceDotWithComma }}</a>
                          </template>
                        </td>
                      </template>
                      <td class="pa-0 text-right">
                        <template v-if="!item.isinformation">
                          {{ item.total }}
                        </template>
                      </td>
                      <td class="pa-0" @click.prevent="checkEditable($event, index)">
                        <template v-if="!item.isinformation">
                          <template v-if="!item.isedit">
                            <span class="pa-1">{{ item.batchnumber }}</span>
                          </template>
                          <template v-else>
                            <template v-if="(item.isproduction ? (!orderModel.isproductionorder || !item.ispackage) : !item.ispackage) && item.product_type === 'product' && !item.product_notinventoryitem">
                              <template v-if="item.olditem.pickedqty && item.olditem.batchnumber">
                                <span class="pa-1">{{ item.batchnumber }}</span>
                              </template>
                              <template v-else-if="item.isbatch && !isOffer">
                                <v-autocomplete autocomplete="off" :readonly="editDisabled || isOffer || item.olditem.isapproved"
                                  :no-data-text="$t('message.common.noData')"
                                  :rules="item.pickedqty ? $_requiredValidation: []"
                                  v-model="item.batchnumber" @change="checkBatchnumberWithQty(index)" :items="item.batchnumbers" item-text="batchnumber_ref" item-value="batchnumber"
                                  hide-details full-width outlined dense :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                              </template>
                            </template>
                          </template>
                        </template>
                      </td>
                      <td class="pa-0 text-right">
                        <template v-if="!item.isinformation">
                          {{ item.dg }}
                        </template>
                      </td>
                      <td class="pa-1">
                        <!-- <v-btn class="mx-2" text fab dark x-small  > -->
                          <!-- {{item.olditem.pickedqty}} -->
                        <v-icon color="primary" small v-if="canRemoveRow(item)" @click="removeRowHandler(item.id, index)">mdi-minus-circle</v-icon>
                        <!-- </v-btn> -->
                        <!-- <v-btn class="mx-2" text fab dark x-small color="primary" v-if="!item.olditem.isapproved" @click="removeRowHandler(index, item.id)">
                          <v-icon dark>mdi-minus-circle</v-icon>
                        </v-btn> -->
                      </td>
                    </tr>
                    <!-- Commented #13499 -->
                    <tr :key="`material-comments-${item.id || index}-${item.productid || 'new'}`" class="row-package-bg"
                      @click="enableEditRow($event, index)"
                      v-if="(!!item.comments || !!item.hs || !!item.netweight || !!item.grossweight || item.isedit || item.product_issupplieronorder) && !item.is_parent_comments && item.is_show && item.content_show">
                      <td v-if="!isOffer"></td>
                      <td></td>
                      <td :colspan="isOffer ? 9 : 10" class="pa-1" @click.prevent="checkEditable($event, index)">
                        <span class="pa-1" v-if="!item.isedit">{{ item.comments }}</span>
                        <v-textarea v-else rows="1" :readonly="editDisabled || item.olditem.isapproved" @change="changesMade" auto-grow hide-details dense outlined v-model="item.comments"></v-textarea>
                      </td>
                      <template v-if="item.product_issupplieronorder && !item.isinformation">
                        <td colspan="3" class="pa-1" @click.prevent="checkEditable($event, index)">
                          <span class="pa-1" v-if="!item.isedit">
                            <template v-if="item.supplierid">
                              {{ item.customer_name || '' }}
                            </template>
                            <template v-else>
                              {{ $t('message.order.supplierNotSelected') }}
                            </template>
                          </span>
                          <v-autocomplete v-else autocomplete="off"
                            :ref="`searchSupplier_${index}`"
                            @change="setSupplierName(index, item.supplierid)"
                            @keyup="$event.keyCode !== 13 ? loadSuppliers(`searchSupplier_${index}`, index, $event) : ''"
                            :readonly="editDisabled || item.olditem.isapproved"
                            v-model="item.supplierid" :items="item.suppliers" item-text="name" item-value="id"
                            hide-details full-width outlined dense></v-autocomplete>
                        </td>
                        <td colspan="6" class="pa-1" @click.prevent="checkEditable($event, index)">
                          <div class="d-flex" style="gap: 16px;">
                            <div style="flex: 1;">
                              <span class="pa-1" v-if="!item.isedit">HS: {{ item.hs }}</span>
                              <v-text-field v-else dense outlined hide-details label="HS" class="additional-row" v-model="item.hs" :readonly="editDisabled || item.olditem.isapproved" @change="changesMade"></v-text-field>
                            </div>
                            <div style="flex: 1;">
                              <span class="pa-1" v-if="!item.isedit">{{ $t('message.product.weight') }}: {{ item.netweight }}</span>
                              <v-text-field v-else dense outlined hide-details :label="$t('message.product.weight')" class="additional-row" v-model="item.netweight" :readonly="editDisabled || item.olditem.isapproved" @change="onWeightChange(index, item)"></v-text-field>
                            </div>
                            <div style="flex: 1;">
                              <span class="pa-1" v-if="!item.isedit">{{ $t('message.product.grossWeight') }}: {{ item.grossweight }}</span>
                              <v-text-field v-else dense outlined hide-details :label="$t('message.product.grossWeight')" class="additional-row" v-model="item.grossweight" :readonly="editDisabled || item.olditem.isapproved" @change="onWeightChange(index, item)"></v-text-field>
                            </div>
                          </div>
                        </td>
                      </template>
                      <template v-else>
                        <td colspan="9" class="pa-1" @click.prevent="checkEditable($event, index)">
                          <div class="d-flex" style="gap: 16px;">
                            <div style="flex: 1;">
                              <span class="pa-1" v-if="!item.isedit">HS: {{ item.hs }}</span>
                              <v-text-field v-else dense outlined hide-details label="HS" class="additional-row" v-model="item.hs" :readonly="editDisabled || item.olditem.isapproved" @change="changesMade"></v-text-field>
                            </div>
                            <div style="flex: 1;">
                              <span class="pa-1" v-if="!item.isedit">{{ $t('message.product.weight') }}: {{ item.netweight }}</span>
                              <v-text-field v-else dense outlined hide-details :label="$t('message.product.weight')" class="additional-row" v-model="item.netweight" :readonly="editDisabled || item.olditem.isapproved" @change="onWeightChange(index, item)"></v-text-field>
                            </div>
                            <div style="flex: 1;">
                              <span class="pa-1" v-if="!item.isedit">{{ $t('message.product.grossWeight') }}: {{ item.grossweight }}</span>
                              <v-text-field v-else dense outlined hide-details :label="$t('message.product.grossWeight')" class="additional-row" v-model="item.grossweight" :readonly="editDisabled || item.olditem.isapproved" @change="onWeightChange(index, item)"></v-text-field>
                            </div>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </template>
                  <template v-else-if="item.orderindex">
                    <tr :key="`material-split-${item.id || index}-${item.orderindex}`" v-if="item.is_show && item.content_show" class="row-package-bg">
                      <td v-if="!isOffer" class="pa-0">
                        <template v-if="!item.packageid">
                          <v-checkbox dense v-model="item.isapprovedWrapper" @change="checkAllCheckbox()" hide-details class="ma-0" color="primary"></v-checkbox>
                        </template>
                      </td>
                      <td class="pa-1">
                        <v-btn icon small v-if="item.isproduction ? (orderModel.isproductionorder && item.ispackage) : item.ispackage" @click="toggleContentProducts(item.id, index, item.toggle_show)">
                          <v-icon v-if="item.toggle_show">mdi-arrow-up-drop-circle-outline</v-icon>
                          <v-icon v-else>mdi-arrow-down-drop-circle-outline</v-icon>
                        </v-btn>
                      </td>
                      <td class="pa-1">
                        <template v-if="item.olditem.isapproved">
                          <v-icon small>mdi-check-circle-outline</v-icon>
                        </template>
                      </td>
                      <td class="pa-1" colspan="5"></td>
                      <template v-if="!isOffer">
                        <td class="pa-0 text-right">
                          <template v-if="(item.isproduction ? (!orderModel.isproductionorder || !item.ispackage) : !item.ispackage) && item.product_type === 'product' && !item.product_notinventoryitem">
                            <template v-if="item.olditem.isapproved || item.olditem.pickedqty">
                              <span class="pa-1">{{ item.pickedqty }}</span>
                            </template>
                            <v-text-field class="text-right-align" v-else dense outlined hide-details :readonly="editDisabled || isOffer || item.olditem.isapproved" v-model="item.pickedqty" @keyup="!item.olditem.pickedqty ? validateQty(index) : checkPickedQty(index)"
                              @change="setInvoiceQtyAndWarehouseRef(index)"></v-text-field>
                          </template>
                        </td>
                        <td class="pa-0">
                          <template v-if="(item.isproduction ? (!orderModel.isproductionorder || !item.ispackage) : !item.ispackage) && item.product_type === 'product' && !item.product_notinventoryitem">
                            <template v-if="item.olditem.warehouseid && item.olditem.pickedqty">
                              <span class="pa-1">{{ item.warehouse_name }}</span>
                            </template>
                            <v-autocomplete :class="isOrder ? `custom_prepend_icon ${item.warehouseOutOfStock ? 'out_of_stock' : ''}` : ''" @click:prepend="isOrder ? showAvailableDialog(item.productid) : null" :prepend-icon="isOrder ? 'mdi-information' : ''" autocomplete="off" v-else :readonly="editDisabled || isOffer || item.olditem.isapproved"
                              v-model="item.warehouseid" :items="item.warehouses" item-text="warehouse_name" item-value="warehouse_id"
                              hide-details full-width outlined dense @change="checkIfCCSheetIsOpen(index)" :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                          </template>
                        </td>
                        <td class="pa-0">
                          <template v-if="(item.isproduction ? (!orderModel.isproductionorder || !item.ispackage) : !item.ispackage) && item.product_type === 'product' && !item.product_notinventoryitem">
                            <template v-if="item.olditem.locationid && item.olditem.pickedqty">
                              <span class="pa-1">{{ item.warehouselocation_name }}</span>
                              <template v-if="item.olditem.locationid && item.olditem.pickedqty && !item.olditem.isapproved">
                                <v-icon @click.stop="undoPicking(item)" size="20" class="margin-2px float-right">mdi-rotate-left</v-icon>
                              </template>
                            </template>
                            <v-autocomplete autocomplete="off" v-else :readonly="editDisabled || isOffer || item.olditem.isapproved"
                              v-model="item.locationid" :items="item.locations" item-text="location_name" item-value="id"
                              :rules="item.product_type === 'product' && !item.product_notinventoryitem ? (item.pickedqty ? $_requiredValidation : []) : []"
                              hide-details full-width outlined dense @change="getListOfBatchNumbers(index)" :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                          </template>
                        </td>
                      </template>
                      <td colspan="7"></td>
                      <td class="pa-0">
                        <template v-if="item.isproduction ? (!orderModel.isproductionorder || !item.ispackage) : !item.ispackage">
                          <template v-if="item.olditem.pickedqty">
                            <span class="pa-1">{{ item.batchnumber }}</span>
                          </template>
                          <template v-else-if="item.isbatch && !isOffer">
                            <v-autocomplete autocomplete="off" :readonly="editDisabled || isOffer || item.olditem.isapproved"
                              :rules="item.pickedqty ? $_requiredValidation: []"
                              v-model="item.batchnumber" @change="checkBatchnumberWithQty(index)" :items="item.batchnumbers" item-text="batchnumber_ref" item-value="batchnumber"
                              hide-details full-width outlined dense :placeholder="$t('message.common.typeHere')"></v-autocomplete>
                          </template>
                        </template>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                    <!-- Commented #13499 -->
                    <tr :key="`material-split-comments-${item.id || index}-${item.orderindex}`" class="row-package-bg"
                        @click="enableEditRow($event, index)"
                        v-if="(!!item.comments || !!item.hs || !!item.netweight || !!item.grossweight || item.isedit || item.product_issupplieronorder) && item.is_last_split && item.is_show && item.content_show">
                      <td v-if="!isOffer"></td>
                      <td></td>
                      <td :colspan="isOffer ? 9 : 10" class="pa-1" @click.prevent="checkEditable($event, index)">
                        <template v-if="!item.isedit">
                          <span class="pa-1">{{ item.comments }}</span>
                        </template>
                        <v-textarea v-else rows="1" :readonly="editDisabled || item.olditem.isapproved" auto-grow hide-details dense outlined @change="changesMade" v-model="item.comments"></v-textarea>
                      </td>
                      <template v-if="item.product_issupplieronorder">
                        <td colspan="3" class="pa-1" @click.prevent="checkEditable($event, index)">
                          <span class="pa-1" v-if="!item.isedit">
                            <template v-if="item.supplierid">
                              {{ item.customer_name || '' }}
                            </template>
                            <template v-else>
                              {{ $t('message.order.supplierNotSelected') }}
                            </template>
                          </span>
                          <v-autocomplete v-else autocomplete="off"
                            :ref="`searchSupplier_${index}`"
                            @change="setSupplierName(index, item.supplierid)"
                            @keyup="$event.keyCode !== 13 ? loadSuppliers(`searchSupplier_${index}`, index, $event) : ''"
                            :readonly="editDisabled || item.olditem.isapproved"
                            v-model="item.supplierid" :items="item.suppliers" item-text="name" item-value="id"
                            hide-details full-width outlined dense></v-autocomplete>
                        </td>
                        <td colspan="7" class="pa-1" @click.prevent="checkEditable($event, index)">
                          <div class="d-flex" style="gap: 16px;">
                            <div style="flex: 1;">
                              <span class="pa-1" v-if="!item.isedit">HS: {{ item.hs }}</span>
                              <v-text-field v-else dense outlined hide-details v-model="item.hs" class="additional-row" :readonly="editDisabled || item.olditem.isapproved" @change="changesMade"></v-text-field>
                            </div>
                            <div style="flex: 1;">
                              <span class="pa-1" v-if="!item.isedit">{{ $t('message.product.weight') }}: {{ item.netweight }}</span>
                              <v-text-field v-else dense outlined hide-details :label="$t('message.product.weight')" v-model="item.netweight" class="additional-row" :readonly="editDisabled || item.olditem.isapproved" @change="onWeightChange(index, item)"></v-text-field>
                            </div>
                            <div style="flex: 1;">
                              <span class="pa-1" v-if="!item.isedit">{{ $t('message.product.grossWeight') }}: {{ item.grossweight }}</span>
                              <v-text-field v-else dense outlined hide-details :label="$t('message.product.grossWeight')" v-model="item.grossweight" class="additional-row" :readonly="editDisabled || item.olditem.isapproved" @change="onWeightChange(index, item)"></v-text-field>
                            </div>
                          </div>
                        </td>
                      </template>
                      <template v-else>
                        <td colspan="10" class="pa-1" @click.prevent="checkEditable($event, index)">
                          <div class="d-flex" style="gap: 16px;">
                            <div style="flex: 1;">
                              <span class="pa-1" v-if="!item.isedit">HS: {{ item.hs }}</span>
                              <v-text-field v-else dense outlined hide-details v-model="item.hs" class="additional-row" :readonly="editDisabled || item.olditem.isapproved" @change="changesMade"></v-text-field>
                            </div>
                            <div style="flex: 1;">
                              <span class="pa-1" v-if="!item.isedit">{{ $t('message.product.weight') }}: {{ item.netweight }}</span>
                              <v-text-field v-else dense outlined hide-details :label="$t('message.product.weight')" v-model="item.netweight" class="additional-row" :readonly="editDisabled || item.olditem.isapproved" @change="onWeightChange(index, item)"></v-text-field>
                            </div>
                            <div style="flex: 1;">
                              <span class="pa-1" v-if="!item.isedit">{{ $t('message.product.grossWeight') }}: {{ item.grossweight }}</span>
                              <v-text-field v-else dense outlined hide-details :label="$t('message.product.grossWeight')" v-model="item.grossweight" class="additional-row" :readonly="editDisabled || item.olditem.isapproved" @change="onWeightChange(index, item)"></v-text-field>
                            </div>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </template>
                </template>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col cols="8" sm="6" lg="8" class="pl-2 pr-0">
          {{ $t('message.orders.lastUpdated') }}: {{ lastUpdated }}
        </v-col>
        <v-col cols="4" sm="6" lg="4" class="pl-0 pr-0">

              <v-row class="ml-1 mr-1">
                <v-col cols="6" class="body-1 pa-0 pr-0 text-right">{{ $t('message.order.totalCost') }}:</v-col>
                <v-col cols="6" class="body-1 pa-0 pr-5 text-right">{{ grandCostTotal | replaceDotWithComma }}</v-col>
              </v-row>
              <v-row class="ml-1 mr-1 mt-0">
                <v-col cols="6" class="body-1 pa-0 pr-0 text-right">{{ $t('message.orders.totalExVat') }}:</v-col>
                <v-col cols="6" class="body-1 pa-0 pr-5 text-right">{{ grandTotal | replaceDotWithComma }}</v-col>
              </v-row>
              <v-row class="ml-1 mr-1 mt-0">
                <v-col cols="6" class="body-1 pa-0 pr-0 text-right">{{ $t('message.common.total') }} DG (%):</v-col>
                <v-col cols="6" class="body-1 pa-0 pr-5 text-right">{{ totalDG | replaceDotWithComma }}</v-col>
              </v-row>

        </v-col>
      </v-row>
    </v-card-actions>
    <div v-if="restOrderRef" class="ml-2" v-html="restOrderRef"></div>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="saveMaterials(false)" :disabled="loadingProducts" :loading="saveLoading" class="ml-2">{{ $t('message.common.update') }}</v-btn>
      <v-btn color="primary" @click="saveMaterials(true)" :disabled="loadingProducts" :loading="saveLoading" class="ml-2">{{ $t('message.common.updateAndClose') }}</v-btn>
      <v-btn color="info" @click="$router.go(-1)" dark class="ml-2">{{ $t('message.common.backToList') }}</v-btn>
      <v-spacer></v-spacer>
      <!-- <v-btn color="info" @click="purchaseHandler" v-if="showPurchase && !isOffer" class="ml-2">{{ $t('message.order.purchase') }}</v-btn> -->
      <template v-if="orderModel.type !== 'sales'">
        <template v-if="orderModel.type === 'order' || orderModel.type === 'rest_order'">
          <v-menu offset-y v-if="orderModel.id">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="info" class="ml-3" v-on="on" dark v-bind="attrs">
                {{ $t('message.user.email') }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in reportOptions" @click="shareOrderData(item.value)" :key="index">
                <template v-if="item.value === 5">
                  <v-list-item-title>{{ item.text }} {{ orderModel.picklistdownloadedon ? `(${$t('message.order.last')} ${orderModel.picklistdownloadedon})` : '' }}</v-list-item-title>
                </template>
                <template v-else>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </template>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-else>
          <v-menu offset-y v-if="orderModel.id">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="info" class="ml-3" v-on="on" dark v-bind="attrs">
                {{ $t('message.user.email') }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in offerOptions" @click="shareOrderData(item.value)" :key="index">
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-if="orderModel.type === 'order' || orderModel.type === 'rest_order'">
          <v-menu offset-y v-if="orderModel.id">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="info" class="ml-3" dark v-bind="attrs" v-on="on">
                {{ $t('message.order.download') }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item  v-for="(item, index) in reportOptions" @click="downloadOrderData(item.value)" :key="index">
                <template v-if="item.value === 5">
                  <v-list-item-title>{{ item.text }} {{ orderModel.picklistdownloadedon ? `(${$t('message.order.last')} ${orderModel.picklistdownloadedon})` : '' }}</v-list-item-title>
                </template>
                <template v-else>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </template>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-else>
          <v-menu offset-y v-if="orderModel.id">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="info" class="ml-3" dark v-bind="attrs" v-on="on">
                {{ $t('message.order.download') }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item  v-for="(item, index) in offerOptions" @click="downloadOrderData(item.value)" :key="index">
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </template>
    </v-card-actions>
  </v-card>
  <v-fab-transition>
    <v-btn fab bottom right color="primary" small id="scroll__top" fixed v-if="showScrollToTop" @click="scrollToTop">
      <v-icon dark>mdi-chevron-up</v-icon>
    </v-btn>
  </v-fab-transition>
  <!-- Rest order creation dialog -->
  <v-dialog v-model="restOrderObj.dialog" persistent width="600">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t('message.common.warning') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <h2 class="mt-3">{{ $t('message.order.productsNotPicked') }}</h2>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="restOrderObj.withRestOrder()">
          {{ $t('message.order.invoiceWithRest') }}
        </v-btn>
        <v-btn color="primary" @click="restOrderObj.withoutRestOrder()">
          {{ $t('message.order.invoiceWithoutRest') }}
        </v-btn>
        <v-btn color="error" @click="restOrderObj.onCancel()">{{ $t('message.common.cancel') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="availableDialog" persistent width="800">
    <v-card>
      <availble-product :model="productidDialog"></availble-product>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="exitDialog">{{ $t('message.common.close') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="noApprovedRows.dialog" persistent width="600">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t('message.common.warning') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <h2 class="mt-3">{{ $t('message.orders.includeAllApprovedProduct') }}</h2>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :loading="noApprovedRows.loading" @click="noApprovedRows.onSuccess()">{{ $t('message.common.yes') }} </v-btn>
        <v-btn color="error" @click="noApprovedRows.onCancel()">{{ $t('message.common.no') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="createCreditNote.dialog" persistent width="600">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t('message.common.warning') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <h2 class="mt-3">{{ $t('message.orders.totalAmountNegativeWarning') }}</h2>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :loading="createCreditNote.loading" @click="createCreditNote.onSuccess()">{{ $t('message.common.yes') }} </v-btn>
        <v-btn color="error" @click="createCreditNote.onCancel()">{{ $t('message.common.no') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="supplierNotSelected.dialog" persistent width="600">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t('message.common.warning') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <h2 class="mt-3">{{ $t('message.orders.supplierNotSelectedOrder') }}</h2>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :loading="supplierNotSelected.loading" @click="supplierNotSelected.onSuccess()">{{ $t('message.common.yes') }} </v-btn>
        <v-btn color="error" @click="supplierNotSelected.onCancel()">{{ $t('message.common.no') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="approvedNotApprovedRows.dialog" persistent width="600">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t('message.common.warning') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <h2 class="mt-3">{{ $t('message.orders.productNotApprovedExclude') }}</h2>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :loading="approvedNotApprovedRows.loading" @click="approvedNotApprovedRows.onSuccess()">{{ $t('message.common.yes') }} </v-btn>
        <v-btn color="error" @click="approvedNotApprovedRows.onCancel()">{{ $t('message.common.no') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="changesNotSavedObj.dialog" persistent width="600">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t('message.common.warning') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <h2 class="mt-3">{{ $t('message.orders.changesNotSaved') }}</h2>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="changesNotSavedObj.onSuccess()">{{ $t('message.common.yes') }} </v-btn>
        <v-btn color="error" @click="changesNotSavedObj.onCancel()">{{ $t('message.common.no') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="purchaseModelObj.dialog" persistent width="600">
    <v-card>
      <v-card-title class="body grey lighten-2" primary-title>
        {{ $t('message.common.warning') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-3">
        <h2>
          {{ $t('message.order.supplierOrderCreationText') }}
        </h2>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="mb-3">
          <v-btn color="success" :loading="allLoading" @click="purchaseModelObj.onAllProduct">{{ $t('message.common.yes') }} </v-btn>
          <v-btn color="error" class="ml-1" @click="purchaseModelObj.onCancel">{{ $t('message.common.no') }} </v-btn>
        </div>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Import Dialog -->
  <v-dialog persistent max-width="600px" v-model="importDialog">
    <v-card>
      <v-card-title>
        <h3>{{$t('message.common.importProducts')}}</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="importForm" :key="importDialog">
          <v-row>
            <v-col cols="12" lg="12">
              <v-file-input :label="$t('message.product.chooseFile')" accept=".xlsx, .xls" outlined v-model="importFile" hide-details></v-file-input>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-flex class="text-end">
          <v-btn color="success" @click="importFileHandler" :loading="loader">{{$t('message.common.import')}}</v-btn>
          <v-btn color="error" class="ml-1" @click="importDialog = false, $refs.importForm.reset()">{{$t('message.common.close')}}</v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="warningDialog" persistent width="600">
    <v-card>
      <v-card-title class="body grey lighten-2" primary-title>
        {{ $t('message.common.warning') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-3">
        <h3>{{ $t('message.orders.existingDataOverwritten') }}</h3>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mt-2">
        <v-spacer></v-spacer>
        <div class="mb-3">
          <v-btn color="error" @click="importDialog = true, importFile = [], warningDialog = false">{{ $t('message.common.yes') }} </v-btn>
          <v-btn color="info" @click="warningDialog = false">{{ $t('message.common.no') }} </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="undoPick.dialog" persistent width="600">
    <v-card>
      <v-card-title class="body grey lighten-2" primary-title>
        {{ $t('message.common.warning') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-3">
        <h3>{{ $t('message.order.sureToUndo', { qty: undoPick.material ? undoPick.material.qty : '', product_number: undoPick.material ? undoPick.material.number : '' }) }}</h3>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mt-2">
        <v-spacer></v-spacer>
        <div class="mb-3">
          <v-btn color="error" :loading="undoPick.loading" @click="undoPick.onSuccess">{{ $t('message.common.yes') }} </v-btn>
          <v-btn color="info" class="ml-2" @click="undoPick.onClose">{{ $t('message.common.no') }} </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Set common discount for all the rows -->
  <v-dialog v-model="discountObj.dialog" persistent width="550">
    <v-card>
      <v-card-title class="body grey lighten-2" primary-title>
        {{ $t('message.orders.discountForAllPrice') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-3">
        <v-form ref="discountValidation">
          <v-row justify="center">
            <v-col cols="10">
              <v-text-field outlined hide-details dense v-model="discountObj.discount" :rules="discountObj.discount ? $_discountValidation : $_requiredValidation" :label="`${$t('message.product.discount')} %`"></v-text-field>
              <h4 style="color: #d82828;">{{ $t('message.orders.allDataOverwritten') }}</h4>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mt-2">
        <v-spacer></v-spacer>
        <v-btn color="success" @click="discountObj.onSuccess" :loading="discountObj.loading">{{ $t('message.common.update') }} </v-btn>
        <v-btn color="error" @click="discountObj.onClose">{{ $t('message.common.cancel') }} </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Errorfull rows when import -->
  <v-dialog v-model="errorImportDialog" persistent width="1200">
    <v-card>
      <v-card-title class="body grey lighten-2" primary-title>
        {{ $t('message.common.importFailed') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-3">
        <v-simple-table dense class="elevation-1 bordered--table document" style="width: 100%;overflow: hidden">
          <template v-slot:default>
            <tbody>
              <tr v-for="(error, index) in errorStatusImport" :key="index">
                <td class="text-left">
                  {{ error }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mt-2">
        <v-spacer></v-spacer>
        <div class="mb-3">
          <v-btn color="error" @click="errorImportDialog = false">{{ $t('message.common.close') }} </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Add Package to stock -->
  <v-dialog v-model="packagePickObj.dialog" persistent width="1600">
    <v-card>
      <v-card-title class="body grey lighten-2" primary-title>
        {{ $t('message.orders.stockablePackage') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-3">
        <v-form ref="stockablePackageForm">
          <v-simple-table dense class="elevation-1 bordered--table document package_item_table" style="width: 100%;overflow: hidden">
            <template v-slot:default>
              <thead>
                <tr>
                  <th width="30%">{{ $t('message.layout.product') }}</th>
                  <th width="8%">{{ $t('message.order.qty') }}</th>
                  <th width="15%">{{ $t('message.layout.warehouse') }}</th>
                  <th width="15%">{{ $t('message.layout.location') }}</th>
                  <th width="15%">{{ $t('message.whOrder.batch') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(pack, index) in listOfPackageForStock" :key="index">
                  <td class="text-left pa-1">
                    {{ pack.number }} {{ pack.producttext }}
                  </td>
                  <td class="text-left pa-1">
                    <v-text-field dense outlined v-model="pack.qty" :rules="$_requiredValidation" hide-details></v-text-field>
                  </td>
                  <td class="text-left pa-1">
                    <v-autocomplete v-model="pack.warehouseid" :items="listOfWarehouse" item-text="name" item-value="id"
                      hide-details outlined dense :placeholder="$t('message.common.typeHere')"
                      @change="loadStockedLocation(index, pack.warehouseid, pack.productid)"
                      :rules="$_requiredValidation"></v-autocomplete>
                  </td>
                  <td class="text-left pa-1">
                    <v-autocomplete v-model="pack.locationid" :items="pack.listOfLocation" autocomplete="off"  class="mt-1"
                        @keyup="$event.keyCode !== 13 ? getWarehouseLocations(`searchLocation${index}`, index, $event, pack.warehouseid) : ''"
                        :ref="`searchLocation${index}`" outlined dense
                        @click="toggleLocations(index, SHOW)"
                        @focusout="toggleLocations(index, HIDE, pack.locationid)"
                        item-text="name" item-value="id"
                        :rules="pack.warehouseid ? $_requiredValidation : []"
                        :loading="pack.locationLoading"
                        hide-details :placeholder="$t('message.order.searchLocation')">
                        <template v-slot:no-data>
                          <span class="pa-1 caption">{{ $t('message.common.noResults') }}</span>
                        </template>
                      </v-autocomplete>
                  </td>
                  <td class="text-left pa-1">
                    <v-text-field dense v-if="pack.product_batchrequired" :rules="pack.locationid ? $_requiredValidation : []" outlined v-model="pack.batchnumber" hide-details></v-text-field>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mt-2">
        <v-spacer></v-spacer>
        <div class="mb-3">
          <v-btn color="success" :loading="packagePickObj.loading" @click="packagePickObj.onSave">{{ $t('message.common.save') }} </v-btn>
          <v-btn color="error" class="ml-2" @click="packagePickObj.onClose">{{ $t('message.common.close') }} </v-btn>
        </div>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import moment from 'moment'
import goTo from 'vuetify/lib/services/goto'
import CONSTANTS from '@/utils/order.json'
export default {
  data () {
    return {
      availableDialog: false,
      productidDialog: null,
      activeProduct: '',
      orderModel: {},
      offerAcceptedLoading: false,
      listOfMaterials: [],
      loadingLocations: false,
      loadingWarehouse: false,
      loadingSupplier: false,
      loadingBatches: false,
      loadingProducts: false,
      orderId: this.$route.params.order_id,
      saveLoading: false,
      isAllSelected: false,
      orderInfo: {
        state: ''
      },
      lastUpdated: '',
      grandTotal: 0,
      grandCostTotal: 0,
      totalDG: 0,
      invoiceSaveLoading: false,
      isOffer: false,
      isOrder: false,
      listOfCurrencyList: [],
      listOfVAT: [{
        text: '0%',
        value: 0
      }, {
        text: '12%',
        value: 12
      }, {
        text: '25%',
        value: 25
      }],
      isInvoiced: false,
      actionLoading: false,
      commercialInvoiceButtons: [],
      exchangeRate: 0,
      packageReferenceId: 0,
      openStructureref: false,
      packageColor: '',
      addedRandomNumbers: [],
      lastPackageId: null,
      lastIndex: -1,
      restOrderRef: '',
      noApprovedRows: {
        dialog: false
      },
      createCreditNote: {
        dialog: false,
        loading: false
      },
      supplierNotSelected: {
        dialog: false,
        loading: false
      },
      hoveredRowIndex: -1,
      approvedNotApprovedRows: {
        dialog: false
      },
      changesNotSavedObj: {
        dialog: false
      },
      restOrderObj: {
        dialog: false
      },
      productFilter: 1,
      purchaseModelObj: {
        dialog: false
      },
      allLoading: false,
      showPurchase: false,
      deliveryList: [],
      dropIndexesAllowed: [],
      importDialog: false,
      importFile: '',
      loader: false,
      isNothingPicked: false,
      warningDialog: false,
      isAllExpand: false,
      selectedCell: null,
      dragAllowedIndex: [0, 1, 2],
      canDragRow: false,
      rowElement: null,
      showScrollToTop: false,
      errorImportDialog: false,
      errorStatusImport: [],
      lastExpandedView: [],
      listOfZones: [],
      zonesFilter: [],
      openedChildren: [],
      totalAvailableItems: [],
      showScrollToBottom: false,
      packagePickObj: {
        dialog: false
      },
      listOfPackageForStock: [],
      discountObj: {
        dialog: false,
        onSuccess: () => false,
        onClose: () => false
      },
      undoPick: {
        dialog: false,
        loading: false,
        onSuccess: () => false,
        onClose: () => false
      },
      purchaseOrderStock: [],
      newlyAddedRowId: 0,
      latestRemovedItems: [],
      productSearchText: '',
      showProductSearch: false,
      productNameSearchText: '',
      showProductNameSearch: false,
      searchDebounceTimer: null
    }
  },
  computed: {
    ...mapState(['listOfWarehouse']),
    pageHeight () {
      return document.body.scrollHeight
    },
    editDisabled () {
      return this.orderModel.state === 'offer' || this.orderModel.state === 'invoiced' || this.orderModel.state === 'create_order'
    },
    mainActions () {
      let options = [{
        text: this.$t('message.order.pickOrder'),
        value: 'pick',
        show: this.orderModel.type !== 'offer'
      }, {
        text: this.$t('message.orders.printLabels'),
        value: 'print'
      }, {
        text: this.$t('message.order.exportToExcel'),
        value: 'export',
        show: this.orderModel.type !== 'sales'
      }]
      if ((this.orderModel.type === 'offer' && this.orderModel.state !== 'create_order') || ((this.orderModel.type === 'order' || this.orderModel.type === 'rest_order') && !this.isNothingPicked)) {
        options.unshift({
          text: this.$t('message.orders.archicad'),
          value: 'import'
        })
      }
      if (this.showPurchase && !this.isOffer) {
        if (options.findIndex(x => x.value === 'import') === 0) {
          options.splice(1, 0, {
            text: this.$t('message.order.purchase'),
            value: 'purchase'
          })
        } else {
          options.unshift({
            text: this.$t('message.order.purchase'),
            value: 'purchase'
          })
        }
      }
      return options
    },
    canCreateOrder () {
      // Get all selected rows with productid
      const selectedRows = this.listOfMaterials.filter(x => x.isapprovedWrapper && x.productid)

      // If no rows are selected, can't create order
      if (selectedRows.length === 0) {
        return false
      }

      // If any selected row has packageid, mainpackageid, or orderindex, don't allow order creation
      const hasInvalidSelectedRows = selectedRows.some(x => x.packageid || x.mainpackageid || x.orderindex)
      if (hasInvalidSelectedRows) {
        return false
      }

      // Check for valid rows (rows that don't already have an OrderMaterialId)
      const validRows = selectedRows.filter(x =>
        !x.packageid &&
        !x.mainpackageid &&
        !x.orderindex &&
        !x.ordermaterialid // Exclude rows that already exist in an order
      )
      return validRows.length > 0
    },
    offerOptions () {
      return [
        {
          text: this.$t('message.common.offerConfirm'),
          value: 1
        }, {
          text: this.$t('message.common.offerWithZone'),
          value: 7
        }
      ]
    },
    reportOptions () {
      return [{
        text: this.$t('message.common.orderConfirm'),
        value: 1
      }, {
        text: this.$t('message.common.orderConfirmWithData'),
        value: 2
      }, {
        text: this.$t('message.order.confirmationWithZone'),
        value: 7
      }, {
        text: this.$t('message.orders.packList'),
        value: 3
      }, {
        text: this.$t('message.orders.pickList'),
        value: 5
      }, {
        text: this.$t('message.order.purchaseList'),
        value: 6
      }, {
        text: this.$t('message.common.commercialInvoice'),
        value: 4
      }, {
        text: this.$t('message.orders.nvitPackList'),
        value: 8
      }]
    },
    productFilterItems () {
      const baseItems = [{
        text: this.$t('message.tickets.all'),
        value: 1
      }, {
        text: this.$t('message.orders.stockAvailable'),
        value: 2
      }]
      if (this.isOrder) {
        // Show these options only for orders
        baseItems.push({
          text: this.$t('message.orders.inBacklog'),
          value: 3
        }, {
          text: this.$t('message.order.toBePicked'),
          value: 5
        }, {
          text: this.$t('message.common.completed'),
          value: 4
        })
      } else if (this.isOffer && this.orderModel.state === 'accepted') {
        // Show these options only for offers with accepted status
        baseItems.push({
          text: this.$t('message.order.orderCreated'),
          value: 6
        }, {
          text: this.$t('message.order.noOrder'),
          value: 7
        })
      }
      return baseItems
    },
    totalMaterialRows () {
      return this.listOfMaterials.filter(x => x.productid && !x.packageid && !x.mainpackageid && !x.orderindex).length
    }
  },
  watch: {
    showProductSearch (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (this.$refs.productSearchField) {
            this.$refs.productSearchField.focus()
          }
        })
      }
    },
    showProductNameSearch (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (this.$refs.productNameSearchField) {
            this.$refs.productNameSearchField.focus()
          }
        })
      }
    }
  },
  components: {
    AvailbleProduct: () => import('@/components/Warehouse/AvailableProduct')
  },
  created () {
    this.getAllCurrencyList()
    this.deliveryList = [{
      text: '',
      value: ''
    }, {
      text: this.$t('message.orders.unknown'),
      value: 'unknown'
    }, ...this.getFutureWeeks()]
  },
  mounted () {
    this.getSingleRecordHandler()
    this.$store.dispatch('getWarehouse')
    let text = this.$t('message.common.deleteSuccess')
    this.restOrderObj.dialog = false
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === 'ordermaterials') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        for (let i = 0; i < this.latestRemovedItems.length; i++) {
          const itemId = this.latestRemovedItems[i]
          const itemIndex = this.listOfMaterials.findIndex(x => x.id === itemId)
          if (itemIndex !== -1) {
            const packageId = (this.listOfMaterials[itemIndex].packageid || this.listOfMaterials[itemIndex].mainpackageid)
            if (this.listOfMaterials[itemIndex] && (this.listOfMaterials[itemIndex].packageid || this.listOfMaterials[itemIndex].mainpackageid)) {
              let removedItem = this.listOfMaterials.splice(itemIndex, 1)
              if (removedItem && removedItem[0]) this.listOfMaterials = this.listOfMaterials.filter(x => x !== removedItem[0])
              let getPackageIndex = this.listOfMaterials.findIndex(x => x.id === packageId)
              if (getPackageIndex > -1) this.calculateParentData(getPackageIndex, packageId)
              if (getPackageIndex > -1) this.recalculatePackageWeights(getPackageIndex)
            } else {
              if (this.listOfMaterials[itemIndex] && this.listOfMaterials[itemIndex].ispackage) {
                this.deleteSubItems(this.listOfMaterials[itemIndex].id)
                this.listOfMaterials = this.listOfMaterials.filter(x => x.packageid !== this.listOfMaterials[itemIndex].id)
              }
              this.listOfMaterials.splice(itemIndex, 1)
            }
          }
        }
        this.saveMaterials(false)
      }
    })
    this.$eventBus.$on('downloadComplete', () => {
      this.orderModel.picklistdownloadedon = moment().format('DD.MM.YYYY')
    })
  },
  methods: {
    mouseDown (e) {
      this.selectedCell = e.srcElement
      var allowedCell = ['td', 'TD']
      if (!allowedCell.includes(this.selectedCell.tagName)) this.selectedCell = e.srcElement.closest('td')
      if (allowedCell.includes(this.selectedCell.tagName)) {
        var rowNode = this.selectedCell.parentNode
        var nodes = Array.prototype.slice.call(rowNode.children)
        if (this.dragAllowedIndex.includes(nodes.indexOf(this.selectedCell))) {
          this.canDragRow = true
          rowNode.setAttribute('draggable', true)
        } else {
          rowNode.setAttribute('draggable', false)
          this.canDragRow = false
        }
        this.rowElement = rowNode
      }
    },
    mouseReleased () {
      if (this.rowElement) this.rowElement.setAttribute('draggable', true)
    },
    onRowMouseEnter (index) {
      this.hoveredRowIndex = index
    },
    onRowMouseLeave () {
      this.hoveredRowIndex = -1
    },
    addNewProductAfterRow (item, index) {
      // Since plus icon only shows on non-package rows, always add standalone product
      // But check if this row belongs to a package to inherit package context
      const parentPackageId = item.packageid || item.mainpackageid || 0
      this.addNewStandaloneProduct(index, parentPackageId)
    },
    addNewStandaloneProduct (afterIndex, inheritPackageId = 0) {
      // Safety check: ensure afterIndex is valid
      if (afterIndex < 0 || afterIndex >= this.listOfMaterials.length) {
        console.warn('Invalid afterIndex provided to addNewStandaloneProduct:', afterIndex)
        return
      }

      // Find the correct insertion point considering split rows
      let insertAfterIndex = afterIndex
      const currentItem = this.listOfMaterials[afterIndex]

      // Copy zone value from the source row
      const sourceZone = currentItem.zone || ''

      // If the current item has an ID (main product), check if it has split rows
      if (currentItem && currentItem.id) {
        // Find all split rows that belong to this main product
        const splitRows = this.listOfMaterials.filter((row, index) =>
          row.orderindex === currentItem.id && index > afterIndex
        )

        if (splitRows.length > 0) {
          // Find the index of the last split row (compatible with older browsers)
          let lastSplitRowIndex = -1
          for (let i = this.listOfMaterials.length - 1; i >= afterIndex; i--) {
            if (this.listOfMaterials[i].orderindex === currentItem.id) {
              lastSplitRowIndex = i
              break
            }
          }
          if (lastSplitRowIndex > afterIndex) {
            insertAfterIndex = lastSplitRowIndex
          }
        }
      }

      // First, check if the next row after our calculated insertion point is already empty
      const nextRowIndex = insertAfterIndex + 1
      if (nextRowIndex < this.listOfMaterials.length) {
        const nextRow = this.listOfMaterials[nextRowIndex]
        if (!nextRow.productid && !nextRow.isfreight) {
          // Focus on the existing empty row instead of creating a new one
          this.$nextTick(() => {
            try {
              if (this.$refs[`searchInput_${nextRowIndex}`] && this.$refs[`searchInput_${nextRowIndex}`][0]) {
                this.$refs[`searchInput_${nextRowIndex}`][0].focus()
              }
            } catch (error) {
              console.warn('Failed to focus existing empty row:', error)
            }
          })
          return
        }
      }

      // Remove any existing empty rows first to prevent duplicates
      // But preserve the bottom empty row and any empty rows that are in edit mode
      const emptyRows = []
      for (let i = this.listOfMaterials.length - 1; i >= 0; i--) {
        const row = this.listOfMaterials[i]
        if (!row.productid && !row.isfreight && !row.isedit) {
          // Only remove empty rows that are:
          // 1. Not the last row (preserve standard bottom empty row)
          // 2. Not currently being edited
          // 3. Not the row we're about to insert after
          if (i !== this.listOfMaterials.length - 1 && i !== insertAfterIndex + 1) {
            emptyRows.push(i)
          }
        }
      }

      // Remove empty rows from highest index to lowest to avoid index shifting
      emptyRows.forEach(index => {
        this.listOfMaterials.splice(index, 1)
      })

      // Recalculate insertAfterIndex if rows were removed before it
      let adjustedAfterIndex = insertAfterIndex
      emptyRows.forEach(removedIndex => {
        if (removedIndex <= insertAfterIndex) {
          adjustedAfterIndex--
        }
      })

      // Safety check: ensure adjustedAfterIndex is still valid
      if (adjustedAfterIndex < 0 || adjustedAfterIndex >= this.listOfMaterials.length) {
        console.warn('Invalid adjustedAfterIndex after cleanup:', adjustedAfterIndex)
        adjustedAfterIndex = Math.max(0, Math.min(this.listOfMaterials.length - 1, insertAfterIndex))
      }

      // Set package reference based on context
      this.packageReferenceId = inheritPackageId
      this.openStructureref = inheritPackageId > 0 // If part of package, inherit open structure
      this.packageColor = inheritPackageId > 0 ? 'rgba(189, 236, 235, 0.29)' : ''

      // Insert a new empty row after the calculated insertion point
      const newRow = {
        isapproved: false,
        olditem: {},
        products: [],
        is_show: true,
        zonefilter: true,
        content_show: true,
        packageid: inheritPackageId || 0, // Inherit package reference if adding to package content
        mainpackageid: inheritPackageId || 0,
        isopenstructure: false, // New products are not packages themselves
        color: this.packageColor || '',
        isedit: true, // Start in edit mode
        zone: sourceZone // Copy zone value from source row
      }

      // Insert after the calculated position
      this.listOfMaterials.splice(adjustedAfterIndex + 1, 0, newRow)

      // Focus on the new row with error handling
      this.$nextTick(() => {
        const newRowIndex = adjustedAfterIndex + 1
        try {
          if (this.$refs[`searchInput_${newRowIndex}`] && this.$refs[`searchInput_${newRowIndex}`][0]) {
            this.$refs[`searchInput_${newRowIndex}`][0].focus()
          }
        } catch (error) {
          console.warn('Failed to focus new row input:', error)
        }
      })
    },
    /*  */
    dragStart (e, material) {
      if (this.canDragRow) {
        /*  */
        let list = this.$formatter.cloneVariable(this.listOfMaterials)
        list = list.filter(x => x.productid || x.isfreight)
        this.draggingRowItem = material
        var productRowLevel = ''
        /* Find item is global or nested */
        if (material.id && !material.packageid && !material.mainpackageid) productRowLevel = 'top'
        else if (material.packageid || material.mainpackageid) productRowLevel = 'nested'
        this.dropIndexesAllowed = [] // only if item dragged over these index containing rows - can be re-arranged
        switch (productRowLevel) {
          case 'top':
            var topListProducts = list.filter(x => x.id && !x.packageid && !x.mainpackageid && (x.id !== material.id))
            this.dropIndexesAllowed = topListProducts.map(x => list.findIndex(y => y.id === x.id))
            break
          case 'nested':
            /* get it's package id and get products of the package */
            var idPropName = material.ispackage ? 'mainpackageid' : 'packageid'
            var otherProducts = list.filter(x =>
              (
                (x.packageid === material[idPropName]) ||
                (x.mainpackageid === material[idPropName])
              ) &&
              (x.id !== material.id)
            )
            this.dropIndexesAllowed = otherProducts.map(x => list.findIndex(y => y.id === x.id))
            break
          default:
            break
        }
      }
    },
    dragEnter (e, item) {
      if (this.canDragRow) this.dragEnteredRowItem = item
    },
    dragLeave (e, item) {},
    dragOver (e) {},
    dragEnd (e) {
      if (this.canDragRow) {
        let list = this.$formatter.cloneVariable(this.listOfMaterials)
        list = list.filter(x => x.productid || x.isfreight)
        var fromIndex = list.findIndex(x => x.id === this.draggingRowItem.id)
        var toIndex = list.findIndex(x => x.id === this.dragEnteredRowItem.id)
        /* If toIndex is dropAllowedIndexes then move items */
        if (this.dropIndexesAllowed.includes(toIndex)) {
          this.loadingProducts = true
          /* check if dragging material is having splitted rows if yes then move them also */
          var dragItemSplittedRows = list.filter(x => x.orderindex === this.draggingRowItem.id)
          var deleteLength = dragItemSplittedRows.length + 1
          /* check if dropping index material is having splitted rows if yes then move them also - do it only when coming from top to down */
          if (fromIndex < toIndex) {
            var dropItemSplittedRows = list.filter(x => x.orderindex === this.dragEnteredRowItem.id)
            if (toIndex) toIndex += dropItemSplittedRows.length // if 0 then don't increase
          }
          this.performSaveMaterialHandler(true, true, { fromIndex, toIndex, deleteLength }).then(() => {
            this.loadingProducts = false
          })
        }
      }
    },
    // when zone changed make sure we show the row below it's zone (for that re-use the drag/drop logic)
    changeThePositionOfRow (fromIndex) {
      this.loadingProducts = false
      var material = this.listOfMaterials[fromIndex]
      if (material && material.id) {
        var toIndex = this.listOfMaterials.filter(x => x.id !== material.id).findLastIndex(x => x.zone === material.zone)
        if (toIndex >= 0) {
          var targetItem = this.listOfMaterials[toIndex]
          if (targetItem.id) {
            /* check if dragging material is having splitted rows if yes then move them also */
            var dragItemSplittedRows = this.listOfMaterials.filter(x => x.orderindex === targetItem.id)
            var deleteLength = dragItemSplittedRows.length + 1
            /* check if dropping index material is having splitted rows if yes then move them also - do it only when coming from top to down */
            if (fromIndex < toIndex) {
              var dropItemSplittedRows = this.listOfMaterials.filter(x => x.orderindex === targetItem.id)
              if (toIndex) toIndex += dropItemSplittedRows.length // if 0 then don't increase
            } else {
              toIndex = toIndex + 1
            }
            this.performSaveMaterialHandler(true, true, { fromIndex, toIndex, deleteLength }).then(() => {
              this.loadingProducts = false
            })
          }
        }
      }
    },
    /* ---- */
    deleteSubItems (parentId) {
      var getNestedPackage = this.listOfMaterials.filter(x => x.ispackage && x.mainpackageid === parentId)
      if (getNestedPackage != null) {
        getNestedPackage.forEach(item => {
          let getIndex = this.listOfMaterials.findIndex(y => y === item)
          if (getIndex > -1) {
            this.listOfMaterials = this.listOfMaterials.filter(x => x.packageid !== this.listOfMaterials[getIndex].id)
            this.listOfMaterials.splice(getIndex, 1)
          }
          if ((item.isproduction ? this.orderModel.isproductionorder && item.ispackage : item.ispackage)) this.deleteSubItems(item.id)
        })
      }
    },
    exitDialog () {
      this.availableDialog = false
      this.productidDialog = null
    },
    showAvailableDialog (productid) {
      this.productidDialog = productid
      this.availableDialog = true
    },
    downloadOrderData (type) {
      if (this.$store.state.isChangesMade) {
        this.changesNotSavedObj = {
          dialog: true,
          onSuccess: () => {
            this.performSaveMaterialHandler()
              .then(() => {
                this.$store.commit('isChangesMade', false)
                this.getOrderMaterials()
                this.changesNotSavedObj.dialog = false
                if (type === 4) this.performCommercialInvoiceAction('download')
                else if (type === 3) this.$parent.downloadPackListOrder()
                else if (type === 8) this.$parent.downloadNvitPackListOrder()
                else if (type === 5) this.$parent.downloadPickListOrder()
                else if (type === 6) this.$parent.downloadPurchaseListOrder()
                else if (type === 7) this.$parent.downloadOrderWithZone(type)
                else this.$parent.downloadOrder(type)
              })
          },
          onCancel: () => {
            this.changesNotSavedObj.dialog = false
          }
        }
      } else {
        if (type === 4) this.performCommercialInvoiceAction('download')
        else if (type === 3) this.$parent.downloadPackListOrder()
        else if (type === 8) this.$parent.downloadNvitPackListOrder()
        else if (type === 5) this.$parent.downloadPickListOrder()
        else if (type === 6) this.$parent.downloadPurchaseListOrder()
        else if (type === 7) this.$parent.downloadOrderWithZone(type)
        else this.$parent.downloadOrder(type)
      }
    },
    shareOrderData (type) {
      if (this.$store.state.isChangesMade) {
        this.changesNotSavedObj = {
          dialog: true,
          onSuccess: () => {
            this.performSaveMaterialHandler()
              .then(() => {
                this.$store.commit('isChangesMade', false)
                this.getOrderMaterials()
                this.changesNotSavedObj.dialog = false
                this.$parent.getOrderData()
                if (type === 4) this.performCommercialInvoiceAction('share')
                else this.$parent.sendReport(type)
              })
          },
          onCancel: () => {
            this.changesNotSavedObj.dialog = false
          }
        }
      } else {
        this.$parent.getOrderData()
        if (type === 4) this.performCommercialInvoiceAction('share')
        else this.$parent.sendReport(type)
      }
    },
    performCommercialInvoiceAction (type) {
      this.loadingProducts = true
      let selectedMaterials = []
      let model = this.$formatter.cloneVariable(this.listOfMaterials)
      let approvedList = []
      model.map(x => {
        if ((x.productid || x.isfreight) && x.isapprovedWrapper) {
          approvedList.push(x)
        }
        return x
      })
      selectedMaterials = approvedList.map(x => x.id)
      if (selectedMaterials && selectedMaterials.length <= 0) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.orders.invoiceSelectRows') })
        this.loadingProducts = false
      } else {
        this.$_executeApi('post', `commercialinvoices/invoice_materials/${this.orderModel.id}`, selectedMaterials)
          .then((response) => {
            this.getOrderMaterials()
            if (type === 'share') this.$parent.sendReport(4, response.data.id)
            else this.$parent.downloadOrder(4, response.data.id)
          })
          .finally(() => {
            this.loadingProducts = false
          })
      }
    },
    getSingleRecordHandler () {
      this.offerAcceptedLoading = true
      this.$_executeApi('get', `orders/get_order_with_rests/${this.orderId}`)
        .then((result) => {
          if (result.data) {
            let { order, customerinvoicecurrencyid, relatedorders } = result.data
            var model = order
            model.customerinvoicecurrencyid = customerinvoicecurrencyid
            model.picklistdownloadedon = this.$formatter.formatDate(model.picklistdownloadedon, 'DD.MM.YYYY', 'DD.MM.YYYY')
            this.orderModel = model
            if (!this.orderModel.invoicecurrencyid) this.$set(this.orderModel, 'invoicecurrencyid', this.orderModel.customerinvoicecurrencyid || 3)
            this.isOffer = this.orderModel.type === 'offer'
            this.isOrder = this.orderModel.type === 'order' || this.orderModel.type === 'rest_order'
            this.getExchangeRate(this.orderModel.invoicecurrencyid)
            if (relatedorders && relatedorders.length > 0) {
              let relatedRef = ''
              for (let i = 0; i < relatedorders.length; i++) {
                relatedRef += `${this.$t('message.orders.restOrder')}<a class="ml-1 mr-1" href='/orders/edit/${relatedorders[i].orderid}/view'>${relatedorders[i].ordernumber}</a>${this.$t('message.tickets.created')}:`
                let user = relatedorders[i].ordercreatedby === -100 ? 'SuperAdmin' : `${relatedorders[i].ordercreatedbyfirstname || ''} ${relatedorders[i].ordercreatedbylastname || ''}`
                relatedRef += `${(relatedorders[i] && relatedorders[i].ordercreatedon) ? `${this.$formatter.formatDate(relatedorders[i].ordercreatedon, 'DD.MM.YYYY HH:mm:ss', 'DD.MM.YYYY HH:mm:ss')}, ${user || ''}` : ''}<br />`
              }
              this.restOrderRef = relatedRef
            }
            this.getOrderMaterials()
          }
        })
        .finally(() => {
          this.offerAcceptedLoading = false
        })
    },
    zoneFilterHandler () {
      if (this.zonesFilter) {
        this.loadingProducts = true
        let materials = this.$formatter.cloneVariable(this.listOfMaterials)
        materials.map(x => {
          if (!x.packageid && !x.mainpackageid) {
            if ((this.zonesFilter.includes(x.zone) || !x.productid)) {
              x.zonefilter = true
            } else if (this.zonesFilter.includes('all')) {
              x.zonefilter = true
            } else if ((this.zonesFilter.includes('nozone') && !x.zone && !x.packageid && !x.mainpackageid && !x.orderindex)) {
              x.zonefilter = true
            } else x.zonefilter = false
          }
          return x
        })
        this.listOfMaterials = materials
        materials.map(x => {
          if (x.packageid || x.mainpackageid) {
            if (x.packageid && this.checkIfParentExists(x.packageid)) x.zonefilter = true
            else if (x.mainpackageid && this.checkIfParentExists(x.mainpackageid)) x.zonefilter = true
            else x.zonefilter = false
          }
          if (x.orderindex) {
            if (x.orderindex && this.checkIfParentExists(x.orderindex)) x.zonefilter = true
          }
          return x
        })
        this.listOfMaterials = materials
        setTimeout(() => {
          this.loadingProducts = false
        }, 10)
      }
    },
    checkIfParentExists (id) {
      return this.listOfMaterials.find(x => x.id === id && x.zonefilter)
    },
    async getOrderMaterials () {
      return new Promise((resolve, reject) => {
        this.loadingProducts = true
        let modelObj = { orderid: this.orderId, zones: this.zonesFilter }
        this.$_executeApi('post', 'ordermaterials/get_materials_list', modelObj)
          .then(async (response) => {
            // let { materials, available, supplierlist, warehouseview, locationview, batchnumberview } = response.data
            let { materials, available, warehouseview, locationview, batchnumberview, zones, zonesfilterapplied, purchaseorderstockview } = response.data
            this.totalAvailableItems = available
            // set zone values on dropdown
            let zoneValues = []
            zones.map((x, i) => {
              if (i === 0) zoneValues.push({ text: this.$t('message.tickets.all'), value: x })
              else if (i === 1) zoneValues.push({ text: this.$t('message.orders.noZone'), value: x })
              zoneValues.push({ text: x, value: x })
            })
            this.listOfZones = zoneValues
            this.zonesFilter = zonesfilterapplied
            let isAlignIndex = false
            this.isNothingPicked = false
            let model = materials
            this.showPurchase = false
            for (let i = 0; i < model.length; i++) {
              if ((this.zonesFilter.includes(model[i].zone) || this.zonesFilter.includes('all')) || (this.zonesFilter.includes('nozone') && !model[i].zone)) model[i].zonefilter = true
              else model[i].zonefilter = false
              if (model[i].orderindex) {
                const parentObj = model.find(x => x.id === model[i].orderindex && x.zonefilter)
                if (parentObj) model[i].zonefilter = true
              }
              if (!isAlignIndex) isAlignIndex = model[i].alignindex === null
              const materialQtyWithoutFormat = model[i].qty
              model[i].qty = this.$formatter.replaceDotWithComma(model[i].qty)
              model[i].pickedqty = this.$formatter.replaceDotWithComma(model[i].pickedqty)
              model[i].invoiceqty = this.$formatter.replaceDotWithComma(model[i].invoiceqty)
              model[i].price = this.$formatter.replaceDotWithComma(model[i].price)
              model[i].product_salesprice = this.$formatter.replaceDotWithComma(model[i].product_salesprice)
              model[i].costprice = this.$formatter.replaceDotWithComma(model[i].costprice)
              model[i].purchaseprice = this.$formatter.replaceDotWithComma(model[i].purchaseprice)
              model[i].discount = this.$formatter.replaceDotWithComma(model[i].discount)
              model[i].total = this.$formatter.replaceDotWithComma(model[i].total)
              model[i].dg = this.$formatter.replaceDotWithComma(model[i].dg)
              model[i].netweight = this.$formatter.replaceDotWithComma(model[i].netweight)
              model[i].grossweight = this.$formatter.replaceDotWithComma(model[i].grossweight)
              if (!this.isNothingPicked) {
                this.isNothingPicked = +this.$formatter.replaceCommaWithDot(model[i].pickedqty) > 0
              }
              model[i].index = i
              model[i].is_show = true

              if (this.lastExpandedView.find(y => y.id === model[i].id)) {
                model[i].content_show = false
                model[i].toggle_show = true
              } else {
                model[i].toggle_show = false
                model[i].content_show = true
              }

              if (model[i].invoice_id && !this.isInvoiced) this.isInvoiced = true
              model[i].olditem = this.$formatter.cloneVariable(model[i])
              model[i].real_sales_price = model[i].price
              model[i].real_cost_price = model[i].costprice
              model[i].isbatch = model[i].product_batchrequired
              model[i].isopenstructure = model[i].product_openstructure
              if (model[i].isfreight) {
                model[i].producttext = 'Frakt'
                model[i].number = '1000'
              }

              // get available stocks
              if (model[i].productid) {
                this.loadingSupplier = true
                let availableObj = available.find(x => x.productid === model[i].productid) // await this.getStockListHandler(model[i].product_id)
                model[i].available = availableObj ? availableObj.available : 0
                this.loadingSupplier = false

                // check qty greater than available if is it OFFER
                if (this.isOffer) {
                  const qty = +this.$formatter.replaceCommaWithDot(model[i]['qty'] || 0)
                  const available = +this.$formatter.replaceCommaWithDot(model[i]['available'] || 0)
                  if (qty > available) {
                    model[i].qtyTrue = true
                  } else model[i].qtyTrue = false
                }
              }
              // set suppliers
              if (model[i].productid && model[i].product_issupplieronorder && model[i].supplierid) {
                model[i].suppliers = [{ id: model[i].supplierid, name: model[i].customer_name }]
              }

              // get warehouses
              let warehouses = []
              if (!this.isOffer && model[i].productid && (!model[i].olditem.warehouseid || !model[i].pickedqty)) {
                this.loadingWarehouse = true
                let warehouseListView = (model[i].supplierorderitemid) ? purchaseorderstockview : warehouseview
                if (model[i].supplierorderitemid) {
                  warehouseListView = purchaseorderstockview.filter(x => x.orderitemid === model[i].supplierorderitemid)
                }
                warehouses = warehouseListView.filter(x => x.warehouse_id && x.productid === model[i].productid && x.onstock > 0) // await this.getWarehouseStockHandler(model[i].productid)

                if (model[i].supplierorderitemid) {
                  const qties = warehouses ? warehouses.map(x => x.onstock) : []
                  const availQtyOnWarehouse = qties.reduce((sum, a) => sum + a, 0) || 0
                  if (model[i].supplierorderactualstatus === 'received' && (materialQtyWithoutFormat > availQtyOnWarehouse)) {
                    warehouses = warehouseview.filter(x => x.warehouse_id && x.productid === model[i].productid && x.onstock > 0) // await this.getWarehouseStockHandler(model[i].productid)
                  }
                }
                this.purchaseOrderStock = warehouses || []
                model[i].warehouses = warehouses
                this.loadingWarehouse = false
              }
              // get locations
              if (model[i].warehouseid && (!model[i].olditem.pickedqty || !model[i].olditem.locationid || !model[i].olditem.batchnumber)) {
                this.loadingLocations = true
                let locations = locationview.filter(x => x.productid === model[i].productid && x.on_stock > 0) // await this.getStockHandler(model[i].warehouseid, model[i].productid)
                model[i].locations = locations
                if (model[i].locationid) {
                  let batchnumbers = batchnumberview.filter(x => x.locationid === model[i].locationid && x.productid === model[i].productid) // await this.getBatchNumbersHandler(model[i].productid, model[i].locationid)
                  model[i].batchnumbers = batchnumbers
                }
                this.loadingLocations = false
              }

              // check if the price on sales and product card is different!
              const offerSalePrice = +this.$formatter.replaceCommaWithDot(model[i].price)
              const productSalePrice = +this.$formatter.replaceCommaWithDot(model[i].product_salesprice)
              if (offerSalePrice < 0) model[i].ispriceiscrepency = true
              else if (this.orderModel.type === CONSTANTS.OFFER && (this.orderModel.state !== CONSTANTS.CREATE_ORDER)) {
                const discrepancy = Math.abs(productSalePrice - offerSalePrice)
                model[i].ispriceiscrepency = discrepancy > 0.5
              }
            }
            let user = ''
            if (model[0]) {
              user = model[0].updatedby === -100 ? 'SuperAdmin' : `${model[0].updatedbyname || ''}`
            }
            this.lastUpdated = `${(model[0] && model[0].updatedon) ? `${this.$formatter.formatDate(model[0].updatedon, 'DD.MM.YYYY HH:mm:ss', 'DD.MM.YYYY HH:mm:ss')}, ${user || ''}` : ''}`
            const getPackageIds = model.filter(x => x.ispackage).map(x => x.id)
            let products = []
            getPackageIds.map(x => {
              // splitting logic inside package content and sort them
              var getProducts = model.filter(y => y.packageid === x && !y.orderindex)
              var getSplitChildProducts = model
              var getParent = model.find(y => y.id === x)
              products.push(getParent)
              getProducts.map(x => {
                x.isopenstructure = getParent.product_openstructure
                return x
              })
              let getCount = -1
              let childRefs = []
              getSplitChildProducts.map((y) => {
                const getParentIndex = getProducts.findIndex(j => j.id === y.orderindex)
                if (getParentIndex > -1) {
                  if (!childRefs.includes(getProducts[getParentIndex].id)) {
                    getCount = getParentIndex + 1
                  } else getCount++
                  childRefs.push(y.orderindex)
                  getProducts.splice(getCount, 0, y)
                }
              })
              products.push(...getProducts)
            })
            const individualProducts = model.filter(x => !x.ispackage && !x.packageid)
            products.push(...individualProducts)
            // splitting logic with extra flags
            products.map(z => {
              if (!this.showPurchase && !z.pickedqty) this.showPurchase = true
              if (z.orderindex) {
                const getParent = products.find(x => x.id === z.orderindex)
                const getParentIndex = products.findIndex(x => x.id === z.orderindex)
                if (getParentIndex > -1) products[getParentIndex].is_parent_comments = true
                let lastSplitId = 0
                if (getParent) {
                  const getChilds = products.filter(x => x.orderindex === getParent.id)
                  getChilds.map((y, index) => {
                    if ((getChilds.length - 1) === index) lastSplitId = y.id
                    return y
                  })
                }
                const getSplittedLastIndex = products.findIndex(x => x.id === lastSplitId)
                if (getSplittedLastIndex > -1) products[getSplittedLastIndex].is_last_split = true
              }
              if (z.packageid || z.mainpackageid) {
                z.content_show = false
              }
            })

            let totalProducts = products
            if (!isAlignIndex) totalProducts = products.sort((a, b) => (a.index > b.index) ? 1 : ((b.index > a.index) ? -1 : 0))
            this.listOfMaterials = totalProducts
            resolve()
            // this.toggleAllPackages()
            setTimeout(async () => {
              let materials = this.$formatter.cloneVariable(this.listOfMaterials)
              for (let i = 0; i < this.lastExpandedView.length; i++) {
                const x = this.lastExpandedView[i]
                const getIndex = materials.findIndex(y => y.id === x)
                const getObj = materials.find(y => y.id === x)
                if (getIndex !== -1 && getObj && getObj.zonefilter) {
                  materials = await this.toggleContentProducts(x, getIndex, getObj.toggle_show)
                }
              }

              this.calculateGrandSum()
              this.calculateTotalDGValues()
              this.packageColor = ''
              this.packageReferenceId = 0
              this.openStructureref = false
              setTimeout(() => {
                this.addNewProductRow(-1)
                this.$store.commit('isChangesMade', false)
                this.onScroll()
                this.filterItemsByStatus()
              })
            })
          })
          .catch(() => {
            resolve()
          })
          .finally(() => {
            this.loadingProducts = false
          })
      })
    },
    getStockListHandler (productid) {
      let filterObj = {
        searchterm: '',
        warehouse: null,
        productid
      }
      return new Promise((resolve, reject) => {
        this.$_executeApi('post', `stocks/filter`, filterObj)
          .then(response => {
            let model = response.data ? response.data.items : []
            if (model) {
              const available = model.filter(obj => obj.productid === productid).map(obj => obj.available)
              resolve(available || [])
            } else resolve([])
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    saveMaterials (isClose, showNotify = true) {
      if (this.$refs.materialForm.validate()) {
        this.saveLoading = true
        this.performSaveMaterialHandler()
          .then((response) => {
            this.updateCurrencyOnOrder(this.orderModel.invoicecurrencyid)
            this.$store.commit('isChangesMade', false)
            if (showNotify) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
            }
            if (isClose) this.$router.push('/orders')
            else {
              this.getSingleRecordHandler()
            }
            this.$parent.getOrderData()
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
      // else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    performSaveMaterialHandler (isDragAndDrop = false, ismove = false, moveObject = null) {
      let list = this.$formatter.cloneVariable(this.listOfMaterials)
      this.lastExpandedView = this.listOfMaterials.filter(x => x.toggle_show && !x.packageid).map(x => x.id) || []
      list = list.filter(x => x.productid || x.isfreight)
      var isNegativePrice = false
      list.map(x => {
        if (!x.olditem.isapproved) x.isapproved = false
        x.qty = this.$formatter.replaceCommaWithDot(x.qty)
        x.pickedqty = this.$formatter.replaceCommaWithDot(x.pickedqty)
        if ((x.pickedqty && (!x.warehouseid || !x.locationid)) || (x.pickedqty && x.isbatch && (!x.warehouseid || !x.locationid || !x.batchnumber))) {
          x.pickedqty = null
        }
        if (!x.pickedqty) {
          x.warehouseid = null
          x.locationid = null
          x.batchnumber = null
        }
        if (x.isbatch && x.locationid && !x.batchnumber) x.locationid = 0
        x.invoiceqty = this.$formatter.replaceCommaWithDot(x.invoiceqty)
        x.price = this.$formatter.replaceCommaWithDot(x.price)
        if (!isNegativePrice && +x.price < 0) {
          isNegativePrice = true
        }
        x.costprice = this.$formatter.replaceCommaWithDot(x.costprice)
        x.purchaseprice = this.$formatter.replaceCommaWithDot(x.purchaseprice)
        x.discount = this.$formatter.replaceCommaWithDot(x.discount)
        x.total = this.$formatter.replaceCommaWithDot(x.total)
        x.dg = this.$formatter.replaceCommaWithDot(x.dg)
        x.netweight = this.$formatter.replaceCommaWithDot(x.netweight)
        x.grossweight = this.$formatter.replaceCommaWithDot(x.grossweight)
        return x
      })
      // Move Material Place on drag and drop
      if (ismove && moveObject && list.length) list.splice(moveObject.toIndex, 0, ...list.splice(moveObject.fromIndex, moveObject.deleteLength))
      if (!isDragAndDrop) {
        this.$store.commit('isChangesMade', false)
        if (!isNegativePrice) {
          return this.$_executeApi('post', `ordermaterials/update_materials/${this.orderId}`, list)
            .then((result) => {
              if (result && result.data) this.newlyAddedRowId = result.data
            })
        } else {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.orders.valuesCannotBeNegative') })
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject()
        }
      } else {
        const formatedList = this.$formatter.cloneVariable(list)
        formatedList.map(x => {
          x.qty = this.$formatter.replaceDotWithComma(x.qty)
          x.pickedqty = this.$formatter.replaceDotWithComma(x.pickedqty)
          x.invoiceqty = this.$formatter.replaceDotWithComma(x.invoiceqty)
          x.price = this.$formatter.replaceDotWithComma(x.price)
          x.costprice = this.$formatter.replaceDotWithComma(x.costprice)
          x.purchaseprice = this.$formatter.replaceDotWithComma(x.purchaseprice)
          x.discount = this.$formatter.replaceDotWithComma(x.discount)
          x.total = this.$formatter.replaceDotWithComma(x.total)
          x.dg = this.$formatter.replaceDotWithComma(x.dg)
          x.netweight = this.$formatter.replaceDotWithComma(x.netweight)
          x.grossweight = this.$formatter.replaceDotWithComma(x.grossweight)
          return x
        })
        this.listOfMaterials = formatedList
        this.addAdditionalRowForNew()
        this.changesMade()
        return Promise.resolve()
      }
    },
    savePackageMaterial (payload) {
      payload = this.$formatter.cloneVariable(payload)
      if (this.$refs.materialForm.validate()) {
        if (!payload.olditem.isapproved) payload.isapproved = false
        payload.qty = this.$formatter.replaceCommaWithDot(payload.qty)
        payload.pickedqty = this.$formatter.replaceCommaWithDot(payload.pickedqty)
        payload.invoiceqty = this.$formatter.replaceCommaWithDot(payload.invoiceqty)
        payload.price = this.$formatter.replaceCommaWithDot(payload.price)
        payload.costprice = this.$formatter.replaceCommaWithDot(payload.costprice)
        payload.purchaseprice = this.$formatter.replaceCommaWithDot(payload.purchaseprice)
        payload.discount = this.$formatter.replaceCommaWithDot(payload.discount)
        payload.total = this.$formatter.replaceCommaWithDot(payload.total)
        payload.dg = this.$formatter.replaceCommaWithDot(payload.dg)
        return this.$_executeApi('post', 'ordermaterials', payload)
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    selectToBeApproved () {
      let list = this.$formatter.cloneVariable(this.listOfMaterials)
      list.map(x => {
        let qty = +this.$formatter.replaceCommaWithDot(x.qty || 0)
        // let pickedqty = +this.$formatter.replaceCommaWithDot(x.pickedqty || 0)
        if (x.productid && (((qty >= 0 || qty <= 0) || x.isfreight || x.isinformation) || (x.ispackage && x.pickedallqties))) {
          if (this.isAllSelected) {
            // x.isapproved = true
            x.isapprovedWrapper = true
          } else {
            // x.isapproved = false
            x.isapprovedWrapper = false
          }
        }
        return x
      })
      this.listOfMaterials = list
    },
    checkAllCheckbox () {
      const isSomeSelected = this.listOfMaterials.find(x => !x.isapprovedWrapper)
      if (isSomeSelected) {
        this.isAllSelected = false
      }
    },
    stockablePackage (listOfPackages) {
      if (!listOfPackages) listOfPackages = []
      const packages = this.$formatter.cloneVariable(this.listOfMaterials.filter(x => x.isapprovedWrapper && listOfPackages.includes(x.id)))
      if (packages.length > 0) {
        this.listOfPackageForStock = packages
        this.packagePickObj = {
          dialog: true,
          loading: false,
          onSave: () => {
            if (this.$refs.stockablePackageForm.validate()) {
              this.packagePickObj.loading = true
              const list = this.$formatter.cloneVariable(this.listOfPackageForStock)
              list.map(x => {
                x.qty = this.$formatter.replaceCommaWithDot(x.qty)
                x.invoiceqty = x.qty
                x.price = this.$formatter.replaceCommaWithDot(x.price)
                x.costprice = this.$formatter.replaceCommaWithDot(x.costprice)
                x.purchaseprice = this.$formatter.replaceCommaWithDot(x.purchaseprice)
                x.discount = this.$formatter.replaceCommaWithDot(x.discount)
                x.total = this.$formatter.replaceCommaWithDot(x.total)
                x.dg = this.$formatter.replaceCommaWithDot(x.dg)
                return x
              })
              this.$_executeApi('post', 'ordermaterials/add_production_products_to_stock', list)
                .then(async () => {
                  this.packagePickObj.loading = false
                  this.packagePickObj.dialog = false
                  this.getSingleRecordHandler()
                  this.$parent.getOrderData()
                })
            } else {
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
              this.packagePickObj.loading = false
            }
          },
          onClose: () => {
            this.packagePickObj.dialog = false
            this.getSingleRecordHandler()
            this.$parent.getOrderData()
          }
        }
      } else {
        this.getSingleRecordHandler()
        this.$parent.getOrderData()
      }
    },
    createOrderHandler () {
      // Get all selected rows first
      const allSelectedRows = this.listOfMaterials.filter(x => x.isapprovedWrapper && x.productid)

      // Check if any selected row has packageid, mainpackageid, or orderindex
      const hasInvalidSelectedRows = allSelectedRows.some(x => x.packageid || x.mainpackageid || x.orderindex)
      if (hasInvalidSelectedRows) {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'error',
          text: this.$t('message.order.cannotCreateOrderWithChildRows')
        })
        return
      }

      // Get selected rows that are eligible for order creation
      const selectedRows = allSelectedRows.filter(x =>
        !x.packageid &&
        !x.mainpackageid &&
        !x.orderindex &&
        !x.ordermaterialid // Exclude rows that already exist in an order
      )

      if (selectedRows.length === 0) {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'error',
          text: this.$t('message.order.noValidRowsForOrder')
        })
        return
      }

      // Prepare data for API call
      const selectedMaterialIds = selectedRows.map(x => x.id)

      // Call the API to create order from offer with selected materials
      this.loadingProducts = true
      this.$_executeApi('post', `orders/create_order_from_offer/${this.orderId}/selective`, selectedMaterialIds)
        .then((response) => {
          this.$root.$emit('snackbar', {
            snackbar: true,
            color: 'success',
            text: this.$t('message.order.orderCreatedSuccessfully')
          })
          // Set filter to "No Order" to show remaining materials without orders
          this.productFilter = 7
          this.getOrderMaterials() // Refresh the materials list
          this.$parent.getOrderData() // Refresh parent order data
        })
        .catch((error) => {
          console.error('Error creating order:', error)
          this.$root.$emit('snackbar', {
            snackbar: true,
            color: 'error',
            text: this.$t('message.common.errorOccurred')
          })
        })
        .finally(() => {
          this.loadingProducts = false
        })
    },
    approveMaterials (approveState) {
      this.loadingProducts = true
      let transformData = { number: { list: ['qty', 'pickedqty', 'invoiceqty', 'price', 'discount', 'total'], format: 'replaceCommaWithDot' } }
      let model = this.$_formatListModel(this.listOfMaterials.filter(x => x.zonefilter), transformData)
      let modelList = []
      model.map(x => {
        if ((x.productid || x.isfreight) && x.isapprovedWrapper && !x.packageid) {
          modelList.push(x)
        }
        return x
      })
      return this.$_executeApi('post', `ordermaterials/approve_materials/${this.orderId}/${approveState || false}`, modelList)
        .then((response) => {
          this.isAllSelected = false
          this.$store.commit('isChangesMade', false)
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
          let isProduction = false
          if (this.orderModel && this.orderModel.isproductionorder) isProduction = true
          if (response && response.data && approveState && isProduction) this.stockablePackage(response.data)
          else {
            this.packagePickObj.dialog = false
            this.getSingleRecordHandler()
            this.$parent.getOrderData()
          }
        })
        .finally(() => {
          this.loadingProducts = false
        })
    },
    // getCostPriceHandler (index, supplierId) {
    //   let materialItem = this.listOfMaterials[index]
    //   if (!materialItem.ispackage && !materialItem.packageid) {
    //     const getSupplier = materialItem.suppliers.find(x => x.supplierid === supplierId)
    //     if (getSupplier && getSupplier.realcostnok) {
    //       let model = this.$formatter.cloneVariable(materialItem)
    //       model.real_cost_price = getSupplier.realcostnok
    //       model.costprice = this.exchangeRate ? this.$formatter.replaceDotWithComma(model.real_cost_price / this.exchangeRate) || '' : ''
    //       this.$set(this.listOfMaterials, index, model)
    //       setTimeout(() => {
    //         let materialObj = this.listOfMaterials[index]
    //         this.calculatePackagePrices(index, materialObj, 'cost')
    //       })
    //       // this.calculateDGValue(index)
    //     }
    //   }
    //   this.changesMade()
    // },
    async addNewProductHandler (productId, index) {
      let product = this.listOfMaterials[index].products.find(x => x.id === productId)
      if (product) {
        this.loadingProducts = true
        await this.newProductHandler(product, index)
        var material = this.listOfMaterials[index]
        if (material && material.zone) {
          var toIndex = this.listOfMaterials.filter((x, i) => i !== index).findLastIndex(x => x.zone === material.zone)
          if (toIndex >= 0) {
            var targetItem = this.listOfMaterials[toIndex]
            if (targetItem.id) {
              var fromIndex = index
              /* check if dragging material is having splitted rows if yes then move them also */
              var dragItemSplittedRows = this.listOfMaterials.filter(x => x.orderindex === targetItem.id)
              var deleteLength = dragItemSplittedRows.length + 1
              /* check if dropping index material is having splitted rows if yes then move them also - do it only when coming from top to down */
              var dropItemSplittedRows = this.listOfMaterials.filter(x => x.orderindex === targetItem.id)
              if (toIndex) toIndex += dropItemSplittedRows.length + 1 // if 0 then don't increase
              this.performSaveMaterialHandler(false, true, { fromIndex, toIndex, deleteLength })
                .then(() => {
                  this.$store.commit('isChangesMade', false)
                  this.getOrderMaterials()
                })
                .catch(() => {
                  this.loadingProducts = false
                })
            } else {
              this.saveMaterialsOnAdd()
            }
          } else {
            this.saveMaterialsOnAdd()
          }
        } else {
          this.saveMaterialsOnAdd()
        }
      }
    },
    saveMaterialsOnAdd () {
      this.performSaveMaterialHandler()
        .then(() => {
          this.$store.commit('isChangesMade', false)
          this.getOrderMaterials()
        })
        .catch(() => {
          this.loadingProducts = false
        })
    },
    async newProductHandler (product, index) {
      return new Promise(async (resolve, reject) => {
        let getDiscount = await this.getDiscountValue(product.id)
        let getMainSupplier = await this.getMainSupplierForProduct(product.id)
        // get available stocks
        let available = 0
        if (this.isOffer) {
          let availableOrigin = await this.getStockListHandler(product.id)
          available = availableOrigin && availableOrigin[0] ? availableOrigin[0] : 0
        }
        // get warehouse
        let warehouseid = 0
        let warehouses = []
        if (!this.isOffer && product.type === 'product' && !product.notinventoryitem) {
          this.loadingWarehouse = true
          warehouses = await this.getWarehouseStockHandler(product.id)
          if (warehouses && warehouses.length === 1) {
            warehouseid = warehouses[0].warehouse_id
          }
          this.loadingWarehouse = false
        }

        // get suppliers
        // this.loadingSupplier = true
        // let suppliers = await this.getProductSuppliers(product.id)
        // let supplierid = 0
        // if (suppliers) {
        //   let getMainSupplier = suppliers.find(x => x.ismain)
        //   supplierid = getMainSupplier ? getMainSupplier.supplierid : 0
        //   const getSupplier = suppliers.find(x => x.supplierid === supplierid)
        //   if (getSupplier && getSupplier.realcostnok) {
        //     product.costprice = getSupplier.realcostnok
        //   }
        // }
        // this.loadingSupplier = false

        // get locations
        let locations = []
        if (warehouseid > 0) {
          this.loadingLocations = true
          locations = await this.getStockHandler(warehouseid, product.id)
          this.loadingLocations = false
        }
        // get sales price value from customer matrix
        let salesPriceFromCustomer = product.salesprice
        getDiscount = getDiscount && getDiscount.data ? getDiscount.data : {}
        let discountForProduct = product.ispackage ? '' : (getDiscount && getDiscount.discount ? this.$formatter.replaceDotWithComma(getDiscount.discount) : '')
        const getSalesPrice = await this.getCustomerPrice(product, discountForProduct)
        if (getSalesPrice) {
          salesPriceFromCustomer = getSalesPrice.price
          discountForProduct = getSalesPrice.discount
        }

        // set purchase price, if the product has main supplier then get the discounted, if not just get the costprice
        let purchasePrice = product.costprice || 0
        if (getMainSupplier && getMainSupplier.data && getMainSupplier.data.discounted) {
          purchasePrice = getMainSupplier.data.discounted || 0
        }
        let exchangeAmt = 0
        if (this.exchangeRate) exchangeAmt = this.exchangeRate
        let currentObj = { ...this.listOfMaterials[index] }
        let productPayload = {
          productid: product.id,
          number: product.number || '',
          producttext: product.name || '',
          product_type: product.type || '', // check this
          unitid: product.productunit_id || 0,
          isbatch: product.batchrequired, // check this
          vat: this.$parent.order && this.$parent.order.ordercustomerdata ? this.$parent.order.ordercustomerdata.VatId : '',
          price: exchangeAmt ? this.$formatter.replaceDotWithComma(salesPriceFromCustomer / exchangeAmt) || '' : '',
          real_sales_price: this.$formatter.replaceDotWithComma(salesPriceFromCustomer) || '',
          real_cost_price: this.$formatter.replaceDotWithComma(product.costprice) || '',
          costprice: exchangeAmt ? this.$formatter.replaceDotWithComma(product.costprice / exchangeAmt) || '' : '',
          purchaseprice: this.$formatter.replaceDotWithComma(purchasePrice) || '',
          warehouses,
          warehouseid,
          locations,
          // suppliers,
          // supplierid,
          color: this.packageColor || '',
          ispackage: product.ispackage || false,
          qty: product.ispackage ? (product.qty ? product.qty : '1,00') : '',
          originalqty: product.ispackage ? (product.qty ? +this.$formatter.replaceCommaWithDot(product.qty) : 1) : '',
          invoiceqty: product.ispackage ? (product.qty ? product.qty : '1,00') : '',
          comments: product.comments || '',
          hs: product.hs || '',
          netweight: this.$formatter.replaceDotWithComma(product.weight || product.netweight) || '',
          grossweight: this.$formatter.replaceDotWithComma(product.grossweight) || '',
          isapproved: false,
          packageid: product.ispackage ? null : (currentObj.packageid || 0),
          isopenstructure: this.openStructureref ? this.openStructureref : (product.openstructure || false),
          isproduction: product.isproduction,
          product_stockitem: product.stockitem,
          available,
          is_show: true,
          zonefilter: true,
          content_show: true,
          discount: discountForProduct || '',
          olditem: {}
        }
        productPayload.mainpackageid = product.ispackage ? currentObj.mainpackageid || 0 : ''
        productPayload.orderid = this.orderId
        this.$set(this.listOfMaterials, index, { ...currentObj, ...productPayload })
        resolve(0)
        setTimeout(() => {
          if (this.$refs[`qtyInput_${index}`] && this.$refs[`qtyInput_${index}`][0]) {
            this.$refs[`qtyInput_${index}`][0].focus()
          }
        })
        this.packageReferenceId = 0
        this.openStructureref = false
        this.packageColor = ''
      })
    },
    async addNewProductToPackage (packageObj, index = -1) {
      const productId = packageObj.id
      this.packageReferenceId = productId
      this.openStructureref = packageObj.isopenstructure || false
      this.packageColor = 'rgba(189, 236, 235, 0.29)'
      let packageObjIndex = { index: -1 }
      if (productId > 0) {
        packageObjIndex.index = this.listOfMaterials.findIndex(x => x.id === productId)
        if (packageObjIndex.index !== -1) packageObjIndex.index = packageObjIndex.index + 1
        await this.getHowManyNestedContent(productId, packageObjIndex)
      }
      if (!this.listOfMaterials.find(x => !x.productid) || !this.listOfMaterials.find(x => !x.productid && x.packageid === productId)) {
        this.addNewProductRow(index, packageObjIndex.index)
      } else if (productId === 0) {
        var getItem = this.$formatter.cloneVariable(this.listOfMaterials[index])
        if (!getItem.originalqty) {
          getItem.originalqty = +this.$formatter.replaceCommaWithDot(getItem.qty)
          this.$set(this.listOfMaterials, index, getItem)
        }
        const item = this.listOfMaterials[index]
        this.calculatePackagePrices(index, item, '')
        this.calculateParentWeights(index, item)
        setTimeout(() => {
          this.setQtyToInvoiceQty(index, 'qty', 'invoiceqty')
        })
        this.focusToNextNewProductRow()
      }
    },
    enableEditRow (event, index) {
      if (this.orderModel.state !== 'create_order') {
        // Performance optimized version that maintains exact original logic
        const originalItem = this.listOfMaterials[index] || {}

        // Step 1: First, disable edit mode for all other items (matches original behavior)
        for (let i = 0; i < this.listOfMaterials.length; i++) {
          if (i !== index && this.listOfMaterials[i].isedit) {
            this.$set(this.listOfMaterials, i, {
              ...this.listOfMaterials[i],
              isedit: false
            })
          }
        }

        // Step 2: Find all split rows for this item (based on current state before toggle)
        const splittedIndexes = []
        if (originalItem.id) {
          for (let i = 0; i < this.listOfMaterials.length; i++) {
            const material = this.listOfMaterials[i]
            if (material.orderindex === originalItem.id && material.is_last_split) {
              splittedIndexes.push(i)
            }
          }
        }

        // Step 3: Calculate the new edit state (toggle)
        const newEditState = originalItem.isedit ? false : true

        // Step 4: Apply the toggled state to all split rows
        splittedIndexes.forEach(splitIndex => {
          this.$set(this.listOfMaterials, splitIndex, {
            ...this.listOfMaterials[splitIndex],
            isedit: newEditState
          })
        })

        // Step 5: Update the main item (only if it has an ID, exactly like original)
        if (originalItem.id) {
          this.$set(this.listOfMaterials, index, {
            ...this.listOfMaterials[index],
            isedit: newEditState
          })

          // Step 6: Focus management (only when enabling edit mode)
          if (newEditState) {
            setTimeout(() => {
              if (event.path && event.path.length > 0) {
                const td = event.path.find(x => x && x.tagName && x.tagName.toLowerCase() === 'td')
                if (td) {
                  var elements = td.querySelectorAll('input, textarea, select')
                  if (elements && elements.length > 0) {
                    requestAnimationFrame(() => {
                      if (elements[0]) elements[0].focus()
                    })
                  }
                }
              }
            }, 50)
          }
        }
      }
    },
    focusToNextNewProductRow (packageIndex = -1, isInit = false, fromIndex = -1) {
      setTimeout(() => {
        // let getLength = this.listOfMaterials.length
        if (packageIndex >= 0) {
          // if (this.$refs[`searchInput_${packageIndex}`]) this.$refs[`searchInput_${packageIndex}`][0].focus()
        } else {
          // if (this.$refs[`searchInput_${getLength - 1}`]) this.$refs[`searchInput_${getLength - 1}`][0].focus()
          if (fromIndex >= 0) {
            const material = this.$formatter.cloneVariable(this.listOfMaterials[fromIndex])
            if (material) {
              material.isedit = false
              this.$set(this.listOfMaterials, fromIndex, material)
            }
          }
        }
        if (isInit && this.newlyAddedRowId) {
          var getFocusIndex = this.listOfMaterials.findLastIndex(x => x.id === this.newlyAddedRowId)
          // var allowSelectQty = this.zonesFilter.includes('all') ? getFocusIndex === (getLength - 2) : true
          // && allowSelectQty
          if (getFocusIndex >= 0) {
            this.$set(this.listOfMaterials, getFocusIndex, { ...this.listOfMaterials[getFocusIndex], qty: '1,00', originalqty: 1, invoiceqty: '1,00', isedit: true })
            this.addNewProductToPackage({ id: 0, color: '' }, getFocusIndex)
            const materials = this.$formatter.cloneVariable(this.listOfMaterials)
            materials.map((x, i) => {
              if (i !== getFocusIndex && x.isedit) x.isedit = false
              return x
            })
            this.listOfMaterials = materials
            setTimeout(() => {
              if (this.$refs[`qtyInput_${getFocusIndex}`]) {
                requestAnimationFrame(() => {
                  if (this.$refs[`qtyInput_${getFocusIndex}`][0]) {
                    this.$refs[`qtyInput_${getFocusIndex}`][0].focus()

                    var input = this.$refs[`qtyInput_${getFocusIndex}`][0].$el
                    var element = input.querySelectorAll('input')
                    if (element && element.length > 0) {
                      requestAnimationFrame(() => {
                        if (element[0]) element[0].select()
                      })
                    }
                  }
                })
              }
            }, 200)
            this.newlyAddedRowId = 0
          }
        }
      }, 200)
    },
    async getHowManyNestedContent (productId, contentCount) {
      contentCount.index += this.listOfMaterials.filter(x => x.packageid === productId).length
      const getNestedContent = this.listOfMaterials.filter(x => x.mainpackageid === productId)
      if (getNestedContent && getNestedContent.length > 0) {
        getNestedContent.map((y) => {
          contentCount.index++
          this.getHowManyNestedContent(y.id, contentCount)
        })
      }
    },
    addNewProductRow (index, packageIndex = -1) {
      const item = this.listOfMaterials[index]
      if (index >= 0) {
        setTimeout(() => {
          this.setQtyToInvoiceQty(index, 'qty', 'invoiceqty')
        })
        if (item.packageid) this.calculatePackagePrices(index, item, '')
        if (item.packageid) this.calculateParentWeights(index, item)
      }
      if (packageIndex >= 0) {
        this.listOfMaterials.splice(packageIndex, 0, {
          isapproved: false,
          olditem: {},
          products: [],
          is_show: true,
          zonefilter: true,
          content_show: true,
          packageid: this.packageReferenceId || 0,
          mainpackageid: this.packageReferenceId || 0,
          isopenstructure: this.openStructureref || false,
          color: this.packageColor || ''
        })
      } else {
        if (this.orderModel.state !== 'invoiced' && this.orderModel.state !== 'create_order') {
          setTimeout(() => {
            this.addAdditionalRowForNew()
          }, 100)
        }
      }
      this.focusToNextNewProductRow(packageIndex, true)
    },
    addAdditionalRowForNew () {
      if (!this.listOfMaterials.find(x => !x.productid)) {
        this.listOfMaterials.push({
          isapproved: false,
          olditem: {},
          products: [],
          is_show: true,
          zonefilter: true,
          content_show: true,
          packageid: this.packageReferenceId || 0,
          mainpackageid: this.packageReferenceId || 0,
          isopenstructure: this.openStructureref || false,
          color: this.packageColor || ''
        })
      }
    },
    calculateParentData (index, productId, isLoading = false, ignoreLoadingReset = false) {
      let getParentObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getParentObj.isopenstructure) {
        let getParentQty = +this.$formatter.replaceCommaWithDot(getParentObj.qty || 0)
        let getContents = []
        if (productId > 0) {
          getContents = this.listOfMaterials.filter(x => ((x.mainpackageid > 0 && x.mainpackageid === getParentObj.id) || x.packageid === getParentObj.id))
        }
        let getCount = getContents.length
        if (getCount > 0) {
          let costPrice = 0
          let salesPrice = 0
          let purchasePrice = 0
          let total = 0
          getContents.map(x => {
            const getQtyValue = x.qty
            let qty = +this.$formatter.replaceCommaWithDot(getQtyValue)
            if (!x.originalqty && x.qty) x.originalqty = qty
            // qty = qty / getParentQty
            costPrice += qty * +this.$formatter.replaceCommaWithDot(x.costprice)
            purchasePrice += qty * +this.$formatter.replaceCommaWithDot(x.purchaseprice)
            let packageSalePrice = 0
            let calculateDiscount = +this.$formatter.replaceCommaWithDot(x.discount || 0)
            const getPrice = +this.$formatter.replaceCommaWithDot(x.price)
            if (calculateDiscount) {
              const discountPrice = (qty * getPrice)
              let rbtValue = (discountPrice * calculateDiscount) / 100
              salesPrice += discountPrice - rbtValue
              const getSalePrice = discountPrice - rbtValue
              packageSalePrice = getSalePrice
            } else {
              const getSalePrice = (qty * getPrice)
              salesPrice += getSalePrice
              packageSalePrice = getSalePrice
            }
            total += packageSalePrice
            return x
          })
          costPrice = (+costPrice / +getParentQty)
          purchasePrice = (+purchasePrice / +getParentQty)
          salesPrice = (+salesPrice / +getParentQty)
          let discount = this.$formatter.replaceCommaWithDot(this.listOfMaterials[index].discount || 0)
          let dg = this.dgCalculationFormula(+costPrice, +salesPrice, +discount)
          costPrice = this.$formatter.replaceDotWithComma(costPrice)
          purchasePrice = this.$formatter.replaceDotWithComma(purchasePrice)
          const getTotal = +getParentQty * +salesPrice
          if (discount && +discount > 0) {
            const getDiscountedVal = (getTotal * +discount / 100)
            // making these values as 2 digit after comma
            const discountAppliedFormat = this.$formatter.replaceDotWithComma(getDiscountedVal)
            const totalAmountFormat = this.$formatter.replaceDotWithComma(getTotal)
            const discountApplied = +this.$formatter.replaceCommaWithDot(discountAppliedFormat)
            const totalAmount = +this.$formatter.replaceCommaWithDot(totalAmountFormat)
            const finalTotal = totalAmount - discountApplied
            total = finalTotal // this.$formatter.replaceDotWithComma(finalTotal)
          } else {
            total = getTotal // this.$formatter.replaceDotWithComma(getTotal)
          }
          total = (isFinite(total) ? (isNaN(total) ? 0 : (total || 0)) : 0)
          total = this.$formatter.replaceDotWithComma(total)
          salesPrice = this.$formatter.replaceDotWithComma(salesPrice)
          let qty = this.listOfMaterials[index].qty
          dg = this.$formatter.replaceDotWithComma(dg)
          this.$set(this.listOfMaterials, index, { ...this.listOfMaterials[index], invoiceqty: qty, dg, costprice: costPrice, purchaseprice: purchasePrice, total: total, price: salesPrice })
          this.calculateGrandSum()
        } else {
          this.$set(this.listOfMaterials, index, { ...this.listOfMaterials[index], dg: '0,00', costprice: '0,00', purchaseprice: '0,00', total: '0,00', price: '0,00', discount: '0,00' })
          this.calculateGrandSum()
        }
        if (getParentObj.mainpackageid > 0) {
          let getIndex = this.listOfMaterials.findIndex(x => x.id === getParentObj.mainpackageid)
          if (getIndex >= 0) this.calculateParentData(getIndex, getParentObj.mainpackageid, true)
          if (!isLoading && !ignoreLoadingReset) this.loadingProducts = false
        } else {
          if (!ignoreLoadingReset) this.loadingProducts = false
        }
      } else {
        // let getParentData = getParentObj
        // let exchangeAmt = 0
        // if (this.exchangeRate) exchangeAmt = this.exchangeRate
        // let costPriceOld = (+this.$formatter.replaceCommaWithDot(getParentData.real_cost_price) / exchangeAmt)
        // let salesPriceOld = (+this.$formatter.replaceCommaWithDot(getParentData.real_sales_price) / exchangeAmt)
        // // let getParentQty = +this.$formatter.replaceCommaWithDot(getParentObj.olditem ? getParentObj.olditem.qty || 0 : getParentObj.qty || 0)
        // let getActiveParentQty = +this.$formatter.replaceCommaWithDot(getParentObj.qty || 0)
        // let calculateQty = +this.$formatter.replaceCommaWithDot(getParentObj.originalqty || 0)
        // let costPrice = calculateQty * +this.$formatter.replaceCommaWithDot(costPriceOld)
        // let salesPrice = calculateQty * +this.$formatter.replaceCommaWithDot(salesPriceOld)
        // let dg = this.dgCalculationFormula(costPrice, salesPrice)
        // dg = this.$formatter.replaceDotWithComma(dg)
        // costPrice = this.$formatter.replaceDotWithComma(costPrice)
        // salesPrice = this.$formatter.replaceDotWithComma(salesPrice)
        // getActiveParentQty = this.$formatter.replaceDotWithComma(getActiveParentQty)
        // this.$set(this.listOfMaterials, index, { ...this.listOfMaterials[index], invoiceqty: getActiveParentQty, dg, costprice: costPrice, total: salesPrice, price: salesPrice })
        // this.calculateGrandSum()
      }
    },
    isIncludeInPurchaseOrder (material) {
      if (material) {
        return !material.ispackage && !material.isfreight && !material.isinformation
      } else return true
    },
    async calculateSubItemsQty (index, productId, packageQty, isTopLevel = true) {
      if (isTopLevel) {
        this.loadingProducts = true
      }

      try {
        let getDirectChild = this.listOfMaterials.filter(x => x.packageid === productId)
        await this.setQtyToInvoiceQty(index, 'qty', 'invoiceqty')
        packageQty = +this.$formatter.replaceCommaWithDot(packageQty)
        this.listOfMaterials.filter(x => x.packageid === productId).map(x => {
          let qty = 0
          if (x.id && x.originalqty) qty = +this.$formatter.replaceCommaWithDot(x.originalqty)
          else if (!x.id && x.originalqty) qty = +this.$formatter.replaceCommaWithDot(x.originalqty)
          x.qty = this.$formatter.replaceDotWithComma(qty * packageQty)
          x.invoiceqty = this.$formatter.replaceDotWithComma(qty * packageQty)
          return x
        })
        // Process nested packages recursively
        await this.calculateForNested(productId, packageQty)
        for (let i = 0; i < getDirectChild.length; i++) {
          let getCountIndex = this.listOfMaterials.findIndex(x => x.id === getDirectChild[i].id)
          if (getCountIndex !== -1) this.calculateDGValue(getCountIndex, true, true) // Skip grand sum calculation
        }
        let getIndex = index
        let getParentId = productId
        if (this.listOfMaterials[index].mainpackageid) {
          let mainParentIndex = this.listOfMaterials.findIndex(y => y.id === this.listOfMaterials[index].mainpackageid)
          if (mainParentIndex !== -1) {
            getIndex = mainParentIndex
            getParentId = this.listOfMaterials[index].mainpackageid
          }
        }
        this.calculateParentData(getIndex, getParentId, true, true)
        // Check if this is the last calculation to complete
        if (isTopLevel) {
          this.calculateGrandSum()
          this.calculateTotalDGValues()
          this.loadingProducts = false
        }
      } catch (error) {
        console.error('Error in calculateSubItemsQty:', error)
        if (isTopLevel) {
          this.loadingProducts = false
        }
        throw error // Re-throw to maintain error handling behavior
      }
    },
    async calculateForNested (productId, packageQty) {
      return new Promise(async (resolve, reject) => {
        var getNestedObj = this.listOfMaterials.find(x => x.id === productId)
        var getNestedQty = packageQty
        if (getNestedObj) {
          getNestedQty = +this.$formatter.replaceCommaWithDot(getNestedObj.qty)
        }
        let getAllItems = this.listOfMaterials.filter(x => x.mainpackageid === productId)

        if (getAllItems.length > 0) {
          // Process nested items sequentially to avoid race conditions
          for (let i = 0; i < getAllItems.length; i++) {
            const element = getAllItems[i]
            let getIndex = this.listOfMaterials.findIndex(y => y === element)
            if (getIndex > -1) {
              const getQty = +this.$formatter.replaceCommaWithDot(this.listOfMaterials[getIndex].originalqty)
              this.listOfMaterials[getIndex].qty = this.$formatter.replaceDotWithComma(getQty * getNestedQty)
              this.listOfMaterials[getIndex].invoiceqty = this.$formatter.replaceDotWithComma(getQty * getNestedQty)
              this.calculateDGValue(getIndex, true, true) // Skip grand sum calculation during bulk operations

              // Pass false to indicate this is NOT a top-level call
              await this.calculateSubItemsQty(getIndex, element.id, (getQty * getNestedQty), false)
            }
          }
        }
        resolve()
      })
    },
    getDiscountValue (productId) {
      return this.$_executeApi('get', `discountgroups/get_by_product_for_order/${productId}?order_id=${this.orderId}`)
    },
    getMainSupplierForProduct (productId) {
      return this.$_executeApi('get', `productsuppliers/get_main_supplier/${productId}`)
    },
    recalculatePackageWeights (packageIndex) {
      if (packageIndex < 0) return
      const pkg = this.listOfMaterials[packageIndex]
      if (!pkg) return
      const packageId = pkg.id
      const parentQty = +this.$formatter.replaceCommaWithDot(pkg.qty || 1) || 1
      const children = this.listOfMaterials.filter(x => (x.packageid === packageId || x.mainpackageid === packageId) && !x.orderindex)
      let totalNetWeight = 0
      let totalGrossWeight = 0
      children.forEach(child => {
        const childQty = +this.$formatter.replaceCommaWithDot(child.qty || 0)
        const lastSplit = this.listOfMaterials.find(x => x.orderindex === child.id && x.is_last_split)
        const weightSource = lastSplit || child
        totalNetWeight += childQty * +this.$formatter.replaceCommaWithDot(weightSource.netweight || 0)
        totalGrossWeight += childQty * +this.$formatter.replaceCommaWithDot(weightSource.grossweight || 0)
      })
      let netweight = totalNetWeight / parentQty
      let grossweight = totalGrossWeight / parentQty
      netweight = isFinite(netweight) && !isNaN(netweight) ? netweight : 0
      grossweight = isFinite(grossweight) && !isNaN(grossweight) ? grossweight : 0
      this.$set(this.listOfMaterials, packageIndex, {
        ...this.listOfMaterials[packageIndex],
        netweight: this.$formatter.replaceDotWithComma(netweight),
        grossweight: this.$formatter.replaceDotWithComma(grossweight)
      })
      // Recurse upward to grandparent packages
      const updatedPkg = this.listOfMaterials[packageIndex]
      const grandParentId = updatedPkg.packageid || updatedPkg.mainpackageid
      if (grandParentId) {
        const grandParentIndex = this.listOfMaterials.findIndex(x => x.id === grandParentId)
        if (grandParentIndex !== -1) this.recalculatePackageWeights(grandParentIndex)
      }
    },
    calculateParentWeights (index, item) {
      const parentId = item.packageid || item.mainpackageid
      if (!parentId) return
      const parentIndex = this.listOfMaterials.findIndex(x => x.id === parentId)
      if (parentIndex === -1) return
      const parentQty = +this.$formatter.replaceCommaWithDot(this.listOfMaterials[parentIndex].qty || 1) || 1
      const children = this.listOfMaterials.filter(x => (x.packageid === parentId || x.mainpackageid === parentId) && !x.orderindex)
      let totalNetWeight = 0
      let totalGrossWeight = 0
      children.forEach(child => {
        const childQty = +this.$formatter.replaceCommaWithDot(child.qty || 0)
        const lastSplit = this.listOfMaterials.find(x => x.orderindex === child.id && x.is_last_split)
        const weightSource = lastSplit || child
        totalNetWeight += childQty * +this.$formatter.replaceCommaWithDot(weightSource.netweight || 0)
        totalGrossWeight += childQty * +this.$formatter.replaceCommaWithDot(weightSource.grossweight || 0)
      })
      let netweight = totalNetWeight / parentQty
      let grossweight = totalGrossWeight / parentQty
      netweight = isFinite(netweight) && !isNaN(netweight) ? netweight : 0
      grossweight = isFinite(grossweight) && !isNaN(grossweight) ? grossweight : 0
      this.$set(this.listOfMaterials, parentIndex, {
        ...this.listOfMaterials[parentIndex],
        netweight: this.$formatter.replaceDotWithComma(netweight),
        grossweight: this.$formatter.replaceDotWithComma(grossweight)
      })
      // Recurse upward to update grandparent packages
      const parent = this.listOfMaterials[parentIndex]
      if (parent.packageid || parent.mainpackageid) {
        this.calculateParentWeights(parentIndex, parent)
      }
    },
    async onQtyChange (index, item) {
      const isPackage = item.isproduction ? (item.ispackage && this.orderModel.isproductionorder) : item.ispackage
      if (isPackage) {
        await this.calculateSubItemsQty(index, item.id, item.qty)
      } else {
        this.addNewProductToPackage({ id: 0, color: '' }, index)
      }
      this.calculateParentWeights(index, item)
    },
    onWeightChange (index, item) {
      this.changesMade()
      this.calculateParentWeights(index, item)
    },
    calculatePackagePrices (index, item, type) {
      const packageId = item.packageid ? item.packageid : item.mainpackageid
      if (packageId > 0) {
        let getIndex = this.listOfMaterials.findIndex(x => x.id === packageId)
        if (getIndex > -1) {
          this.calculateParentData(getIndex, packageId)
          setTimeout(() => {
            if (type === 'cost') this.setQtyToInvoiceQty(index, 'costprice', 'real_cost_price')
            else if (type === 'price') this.setQtyToInvoiceQty(index, 'price', 'real_sales_price')
            else if (type === 'discount') this.calculateDGValue(index, true)
          })
        } else {
          if (type === 'cost') {
            this.setQtyToInvoiceQty(index, 'costprice', 'real_cost_price')
          } else if (type === 'price') {
            this.setQtyToInvoiceQty(index, 'price', 'real_sales_price')
          } else if (type === 'discount') {
            this.calculateDGValue(index, true)
          }
        }
      } else {
        if (type === 'cost') {
          this.setQtyToInvoiceQty(index, 'costprice', 'real_cost_price')
        } else if (type === 'price') {
          this.setQtyToInvoiceQty(index, 'price', 'real_sales_price')
        } else if (type === 'discount') {
          this.calculateDGValue(index, true)
        }
      }
    },
    async setInvoiceQtyAndWarehouseRef (index) {
      await this.setQtyToInvoiceQty(index, 'pickedqty', 'invoiceqty')
      let item = this.$formatter.cloneVariable(this.listOfMaterials[index])
      this.checkWarehouseStock(index, item)
    },
    checkIfCCSheetIsOpen (index) {
      let getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getObj && getObj.warehouseid) {
        return new Promise((resolve, reject) => {
          this.$_executeApi('get', `ccsheets/lock_pick_product/${getObj.productid}/${getObj.warehouseid}`)
            .then((response) => {
              if (response && response.data) {
                // can't pick at this warehouse
                this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.ccsheet.cannotPickAtThisWH') })
                this.$set(this.listOfMaterials, index, { ...getObj, warehouseid: 0 })
                resolve(true)
              } else {
                this.getListOfLocations(index)
                resolve(false)
              }
            })
        })
      } else {
        return Promise.resolve()
      }
    },
    async getListOfLocations (index) {
      this.changesMade()
      let getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getObj) {
        this.loadingLocations = true
        let locations = []
        if (getObj.supplierorderitemid) {
          let filterLocations = this.purchaseOrderStock.filter(x => x.orderitemid === getObj.supplierorderitemid && x.onstock > 0)
          if (filterLocations && filterLocations.length > 0) {
            filterLocations.map(x => {
              x.id = x.locationid
              x.on_stock = x.onstock
              return x
            })
            locations = filterLocations
          } else {
            locations = await this.getStockHandler(getObj.warehouseid, getObj.productid)
          }
        } else {
          locations = await this.getStockHandler(getObj.warehouseid, getObj.productid)
        }
        const pickedqty = +this.$formatter.replaceCommaWithDot(getObj.pickedqty) || 0
        if (locations && locations.length === 1) {
          const onStock = +this.$formatter.replaceCommaWithDot(locations[0].on_stock) || 0
          if (onStock >= pickedqty) {
            getObj.locationid = locations[0].id
          }
        } else {
          getObj.locationid = 0
          getObj.warehouselocation_name = ''
        }
        getObj.locations = locations
        let warehouse = getObj.warehouses.find(x => x.warehouse_id === getObj.warehouseid)
        getObj.warehouse_name = warehouse ? warehouse.warehouse_name : ''
        this.loadingLocations = false
        setTimeout(() => {
          this.$set(this.listOfMaterials, index, getObj)
          setTimeout(() => {
            if (getObj.locationid) this.getListOfBatchNumbers(index)
          }, 5)
        })
      }
    },
    async getListOfBatchNumbers (index) {
      this.changesMade()
      let getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getObj) {
        if (getObj.locations) {
          let currentLocation = getObj.locations.find(x => x.locationid === getObj.locationid)
          if (currentLocation) {
            const onStock = this.$formatter.replaceCommaWithDot(currentLocation.on_stock)
            const pickedQty = this.$formatter.replaceCommaWithDot(getObj.pickedqty)
            if (currentLocation && +onStock < +pickedQty) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
              const newObj = { ...getObj, pickedqty: '' }
              this.$set(this.listOfMaterials, index, newObj)
            } else {
              getObj.warehouselocation_name = currentLocation ? currentLocation.location_name : ''
              setTimeout(() => {
                this.$set(this.listOfMaterials, index, getObj)
              })
            }
          }
        }
        if (getObj.isbatch) {
          this.loadingBatches = true
          let batchNumbers = await this.getBatchNumbersHandler(getObj.productid, getObj.locationid)
          getObj.batchnumbers = batchNumbers
          this.loadingBatches = false
          setTimeout(() => {
            this.$set(this.listOfMaterials, index, getObj)
          })
        }
      }
    },
    getAllCurrencyList () {
      this.$_executeApi('get', 'currencies/get_all_currency_list')
        .then((response) => {
          response.data.sort((a, b) => a.name.localeCompare(b.name))
          this.listOfCurrencyList = response.data
        })
    },
    loadProducts (term, event, index) {
      if ([30, 32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      if (searchText !== null) {
        // let model = {
        //   'expand': [{
        //     'select': ['id', 'name'],
        //     'model': 'ProductUnit',
        //     'on_field': 'id',
        //     'on_parent_field': 'unitid'
        //   }],
        //   'filter': `number contains '${searchText}' AND name contains '${searchText}'`,
        //   'additionalfilters': [`isactive eq 1`],
        //   'skip': 0,
        //   'limit': 50,
        //   'order_by': {
        //     'field': 'number',
        //     'asc_or_desc': 'asc'
        //   }
        // }
        // this.$_executeApi('post', 'products/query', model).then((response) => {
        this.$_executeApi('post', `products/search_products_num_desc?term=${searchText}`).then((response) => {
          if (!this.listOfMaterials[index].products) this.listOfMaterials[index].products = []
          this.listOfMaterials[index].products = []
          if (response.data.length > 0) {
            response.data.forEach(element => {
              element.productName = element.number ? `${element.number} - ${element.name}` : element.name
            })
            // let getPackagesId = this.listOfMaterials.filter(x => x.ispackage).map(x => x.productid)
            this.listOfMaterials[index].products = response.data // .filter(x => !getPackagesId.includes(x.id))
          }
        })
      }
    },
    getWarehouseStockHandler (productid) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `/stocks/get_product_stock_count?product_id=${productid}`)
          .then((result) => {
            let model = result.data
            model = model.filter(x => x.on_stock > 0)
            let transformData = { number: { list: ['on_stock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.warehouse_name = `${x.warehouse_name} (${x.on_stock})`
              x.id = x.warehouseid
              return x
            })
            resolve(model)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getProductSuppliers (productid) {
      return new Promise((resolve, reject) => {
        let query = {
          'expand': [{
            'select': ['name'],
            'model': 'Customer',
            'on_field': 'id',
            'on_parent_field': 'supplierid'
          }],
          filter: `productid eq ${productid}`
        }
        this.$_executeApi('post', '/productsuppliers/query', query)
          .then((result) => {
            resolve(result.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getStockHandler (warehouseId, productid) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `/stocks/get_product_by_warehouse?product_id=${productid}&warehouse_id=${warehouseId}`)
          .then((result) => {
            let model = result.data
            model = model.filter(x => x.on_stock > 0)
            let transformData = { number: { list: ['on_stock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.name = x.location_name
              x.location_name = `${x.location_name} (${x.on_stock})`
              x.id = x.locationid
              return x
            })
            resolve(model)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getCustomerPrice (product, discount) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `customernetprices/get_for_sale_order/${this.orderId}/${product.id}`)
          .then((result) => {
            if (result && result.data) {
              let model = result.data
              if (model && model.salesprice) {
                if (model.salesprice > product.costprice) resolve({ price: model.salesprice, discount: '' })
                else resolve({ price: product.costprice, discount })
              } else {
                resolve({ price: product.salesprice, discount })
              }
            } else {
              resolve({ price: product.salesprice, discount })
            }
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      })
    },
    getBatchNumbersHandler (productid, locationid) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `/warehouseorderitems/get_batchnumbers_by_location?product_id=${productid}&location_id=${locationid}`)
          .then((result) => {
            let model = result.data
            let transformData = { number: { list: ['onstock'], format: 'replaceDotWithComma' } }
            model = this.$_formatListModel(model, transformData)
            model.map(x => {
              x.batchnumber_ref = ''
              x.batchnumber_ref = `${x.batchnumber} (${x.onstock})`
              return x
            })
            resolve(model)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    checkPickedQty (index) {
      let getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getObj) {
        let qty = parseFloat(this.$formatter.replaceCommaWithDot(getObj.qty || 0))
        let pQty = parseFloat(this.$formatter.replaceCommaWithDot(getObj.pickedqty || 0))
        if (qty > 0 && qty < pQty) {
          getObj.qty = this.$formatter.replaceDotWithComma(pQty)
          this.$set(this.listOfMaterials, index, getObj)
        }
      }
    },
    validateQty (index) {
      let getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getObj) {
        let getLocationId = getObj.locationid
        let stockObj = getObj.locations ? getObj.locations.find(x => x.locationid === getLocationId) : null
        let qty = this.listOfMaterials[index].qty ? parseFloat(this.$formatter.replaceCommaWithDot(this.listOfMaterials[index].qty || 0)) : 0
        let pQty = this.listOfMaterials[index].pickedqty ? parseFloat(this.$formatter.replaceCommaWithDot(this.listOfMaterials[index].pickedqty || 0)) : 0
        // eslint-disable-next-line eqeqeq
        if (pQty == 0) {
          getObj.invoiceqty = getObj.qty
          this.$set(this.listOfMaterials, index, getObj)
        }
        if (stockObj) {
          let stockValue = parseFloat(this.$formatter.replaceCommaWithDot(stockObj.on_stock || 0))
          if (stockValue < pQty) {
            getObj.pickedqty = ''
            getObj.invoiceqty = getObj.qty
            this.$set(this.listOfMaterials, index, getObj)
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
            return
          }
        }
        if (qty > 0 && qty < pQty) {
          getObj.pickedqty = ''
          getObj.invoiceqty = getObj.qty
          this.$set(this.listOfMaterials, index, getObj)
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.orderedQtyLessMsg') })
          return
        }
        // Check with batchnumber qty
        let batchObj = getObj.batchnumbers ? getObj.batchnumbers.find(x => x.batchnumber === getObj.batchnumber) : null
        if (batchObj) {
          let stockValue = parseFloat(this.$formatter.replaceCommaWithDot(batchObj.onstock || 0))
          let pickedqty = parseFloat(this.$formatter.replaceCommaWithDot(getObj.pickedqty || 0))
          if (stockValue < pickedqty) {
            getObj.pickedqty = ''
            getObj.invoiceqty = getObj.qty
            this.$set(this.listOfMaterials, index, getObj)
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
          }
        }
      }
    },
    checkBatchnumberWithQty (index) {
      let getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (getObj) {
        let stockObj = getObj.batchnumbers ? getObj.batchnumbers.find(x => x.batchnumber === getObj.batchnumber) : null
        if (stockObj) {
          let stockValue = parseFloat(this.$formatter.replaceCommaWithDot(stockObj.onstock || 0))
          let pickedqty = parseFloat(this.$formatter.replaceCommaWithDot(getObj.pickedqty || 0))
          if (stockValue < pickedqty) {
            getObj.pickedqty = ''
            getObj.invoiceqty = getObj.qty
            this.$set(this.listOfMaterials, index, getObj)
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.whOrder.onstockLessMsg') })
          }
        }
      }
      this.changesMade()
    },
    canRemoveRow (item) {
      // Check if item can be removed (new empty row or unpicked/unapproved existing row)
      if (!item) return false

      // Don't allow removal in certain order states
      if (this.orderModel.state === 'invoiced' || this.orderModel.state === 'create_order') return false

      // For new rows (no ID and empty olditem)
      if (!item.id && (!item.olditem || Object.keys(item.olditem).length === 0)) {
        return true
      }

      // For existing rows, check the traditional conditions
      if (item.olditem) {
        const pickedQty = item.olditem.pickedqty || 0
        const isApproved = item.olditem.isapproved || false
        return !pickedQty && !isApproved
      }

      return false
    },
    removeRowHandler (id = 0, index = -1) {
      // Handle new rows without IDs (directly remove from array)
      if (!id && index >= 0) {
        const item = this.listOfMaterials[index]
        if (item && this.canRemoveRow(item)) {
          const removedParentId = item.packageid || item.mainpackageid
          this.listOfMaterials.splice(index, 1)
          if (removedParentId) {
            const parentIndex = this.listOfMaterials.findIndex(x => x.id === removedParentId)
            if (parentIndex > -1) this.recalculatePackageWeights(parentIndex)
          }
          return
        }
      }

      // Handle existing rows with IDs (server deletion)
      let itemsToBeRemoved = []
      if (!id) {
        let itemsToRemove = this.listOfMaterials.filter(x => x.zonefilter && !x.pickedqty)
        itemsToRemove.map(x => {
          if ((x.productid || x.isfreight) && x.isapprovedWrapper) {
            itemsToBeRemoved.push(x.id)
          }
          return x
        })
      } else itemsToBeRemoved = [id]
      this.latestRemovedItems = []
      if (itemsToBeRemoved.length > 0 && this.listOfMaterials.length >= 1) {
        let payload = { ids: itemsToBeRemoved, url: `ordermaterials/delete_multiple`, module: 'ordermaterials' }
        this.$store.commit('showDeleteDialog', payload)
        this.latestRemovedItems = itemsToBeRemoved
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.noResults') })
      }
    },
    setQtyToInvoiceQty (index, field, mapField) {
      return new Promise((resolve, reject) => {
        this.changesMade()
        let item = this.$formatter.cloneVariable(this.listOfMaterials[index])
        if (field === 'qty') {
          const checkQty = +this.$formatter.replaceCommaWithDot(item.qty)
          if (isNaN(checkQty)) {
            item.qty = 0
            item.originalqty = 0
          }
        }
        if (field === 'qty' && !item.olditem) {
          item.originalqty = +this.$formatter.replaceCommaWithDot(item.qty)
        }
        if (field === 'qty' && this.isOffer) {
          if (item[field] > item['available']) {
            item.qtyTrue = true
          } else item.qtyTrue = false
        }
        if (field === 'pickedqty' && mapField === 'invoiceqty' && item[field]) {
          if (+item[field] === 0) {
            item[mapField] = item.qty
          } else {
            item[mapField] = item[field]
          }
          if (item.orderindex) {
            const getParent = this.listOfMaterials.find(x => x.id === item.orderindex)
            const getParentIndex = this.listOfMaterials.findIndex(x => x.id === item.orderindex)
            const getChilds = this.listOfMaterials.filter(x => x.orderindex === getParent.id)
            if (getParent) {
              const parentObj = { ...this.listOfMaterials[getParentIndex] }
              let formatQty = +this.$formatter.replaceCommaWithDot(parentObj.pickedqty)
              const getQtys = getChilds.map(x => +this.$formatter.replaceCommaWithDot(x.pickedqty))
              const getTotalSum = this.$_getSum(getQtys)
              const getParentInvoiceQty = this.$formatter.replaceDotWithComma(getTotalSum + formatQty)
              this.$set(this.listOfMaterials, getParentIndex, { ...parentObj, invoiceqty: getParentInvoiceQty })
            }
          }
        } else if (field !== 'pickedqty' || mapField !== 'invoiceqty') {
          item[mapField] = item[field] ? item[field] : ''
        }
        setTimeout(() => {
          this.$set(this.listOfMaterials, index, item)
          setTimeout(() => {
            this.calculateDGValue(index, true)
            resolve()
          }, 100)
        }, 10)
      })
    },
    calculateTotalValues (index, skipGrandSum = false) {
      let item = this.$formatter.cloneVariable(this.listOfMaterials[index])
      if (item.qty || item.pickedqty || item.invoiceqty || item.price) {
        this.grandTotal = 0
        this.grandCostTotal = 0
        let transformData = { number: { list: ['pickedqty', 'qty', 'invoiceqty', 'price', 'discount', 'total'], format: 'replaceCommaWithDot' } }
        let model = this.$_formatModel(item, transformData)
        let qtyField = this.orderModel.type === 'offer' ? 'qty' : 'invoiceqty'
        model.total = model[qtyField] * model.price
        if (model.discount) {
          let rbtValue = (model.total * model.discount) / 100
          model.total = model.total - rbtValue
        }
        let transformedData = { number: { list: ['pickedqty', 'qty', 'invoiceqty', 'price', 'discount', 'total'], format: 'replaceDotWithComma' } }
        model = this.$_formatModel(model, transformedData)
        this.$set(this.listOfMaterials, index, model)
      }
      this.changesMade()
      if (!skipGrandSum) {
        this.calculateGrandSum()
      }
    },
    calculateGrandSum () {
      let items = this.$formatter.cloneVariable(this.listOfMaterials)
      if (items && items.length === 0) {
        this.grandTotal = '0,00'
        this.grandCostTotal = '0,00'
      }
      this.grandTotal = 0
      this.grandCostTotal = 0
      items.map(x => {
        if (!x.packageid && !x.orderindex && !x.mainpackageid) {
          let qtyField = this.orderModel.type === 'offer' ? 'qty' : 'invoiceqty'
          const costPrice = parseFloat(+this.$formatter.replaceCommaWithDot(x.costprice || 0))
          const qtyValue = parseFloat(+this.$formatter.replaceCommaWithDot(x[qtyField] || 0))
          this.grandCostTotal += qtyValue * costPrice
          this.grandTotal += parseFloat(+this.$formatter.replaceCommaWithDot(x.total || 0))
        }
      })
    },
    calculateDGValue (index, fromDiscount = false, skipGrandSum = false) {
      if (fromDiscount) this.calculateTotalValues(index, skipGrandSum)
      let item = this.$formatter.cloneVariable(this.listOfMaterials[index])
      let transformData = { number: { list: ['price', 'costprice', 'discount', 'dg'], format: 'replaceCommaWithDot' } }
      let model = this.$_formatModel(item, transformData)
      model.dg = this.dgCalculationFormula(model.costprice, model.price, model.discount)
      if (this.orderModel.type === 'offer') model.invoiceqty = model.qty
      let transformedData = { number: { list: ['price', 'costprice', 'dg', 'discount'], format: 'replaceDotWithComma' } }
      model = this.$_formatModel(model, transformedData)
      this.$set(this.listOfMaterials, index, model)
      if (!skipGrandSum) {
        this.calculateTotalDGValues()
      }
    },
    dgCalculationFormula (price, salesprice, discount) {
      // FORMULA
      // (sales_price - product_costprice) / sales_price * 100 => without discount
      // If Discount
      // let result = sales_price * (100 - discount) / 100
      // (result - costprice) / result * 100
      let getDGValue = 0
      getDGValue = price > 0 ? ((salesprice - price) / salesprice) * 100 : ((salesprice) / salesprice) * 100
      if (discount && discount > 0) {
        let getResult = +salesprice * (100 - discount) / 100
        let dgValue = ((getResult - price) / getResult) * 100
        getDGValue = dgValue
      }
      return (isFinite(getDGValue) ? (isNaN(getDGValue) ? 0 : (getDGValue || 0)) : 0)
    },
    calculateTotalDGValues () {
      let items = this.$formatter.cloneVariable(this.listOfMaterials)
      if (items && items.length === 0) this.totalDG = '0,00'
      let totalPrice = 0
      let totalSalesPrice = 0
      let qtyField = this.orderModel.type === 'offer' ? 'qty' : 'invoiceqty'
      items.map(x => {
        if (!x.packageid && !x.orderindex && !x.mainpackageid) {
          const qty = +this.$formatter.replaceCommaWithDot(x[qtyField] || 0)
          const costprice = +this.$formatter.replaceCommaWithDot(x.costprice || 0)
          const totalExMVA = +this.$formatter.replaceCommaWithDot(x.total || 0)
          totalPrice += parseFloat(qty * costprice)
          totalSalesPrice += parseFloat(totalExMVA)
        }
      })
      totalSalesPrice = parseFloat(totalSalesPrice.toFixed(2))
      const dg = this.dgCalculationFormula(totalPrice, totalSalesPrice)
      this.totalDG = isNaN(dg) ? 0 : dg
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    },
    checkIfCreateRestOrder () {
      let model = this.$formatter.cloneVariable(this.listOfMaterials)
      let approvedList = []
      let notApprovedList = []
      let allApprovedList = []
      let allMaterialApprovedIds = []
      model.map(x => {
        if ((x.productid || x.isfreight || x.isinformation) && x.isapprovedWrapper) {
          if (x.olditem.isapproved) approvedList.push(x)
          else notApprovedList.push(x)
        } else {
          if (x.olditem.isapproved) allApprovedList.push(x)
        }
        if (x.olditem.isapproved) allMaterialApprovedIds.push(x.id)
        return x
      })
      var approvedIds = approvedList.map(x => x.id)
      let isNoneSelected = true
      var getIsNoneSelected = model.map(x => x.isapprovedWrapper)
      getIsNoneSelected.map(x => {
        if (isNoneSelected) {
          if (!x) isNoneSelected = true
          else isNoneSelected = false
        }
        return x
      })
      var type = 0
      var selectedIds = []
      if (isNoneSelected) {
        selectedIds = allApprovedList.map(x => x.id)
        type = 1
      } else if (approvedList.length > 0 && notApprovedList.length <= 0) {
        selectedIds = approvedIds
        type = 2
      } else if (approvedList.length > 0 && notApprovedList.length > 0) {
        selectedIds = approvedIds
        type = 3
      }
      // check for rest order records
      let showRestOrderWarning = false
      model.map(y => {
        if (y.id && !y.olditem.isapproved) showRestOrderWarning = true
      })
      if (showRestOrderWarning) {
        this.restOrderObj = {
          dialog: true,
          withRestOrder: () => {
            this.checkIfInvoiceHasItems(type, selectedIds, allMaterialApprovedIds, true)
            this.restOrderObj.dialog = false
          },
          withoutRestOrder: () => {
            this.checkIfInvoiceHasItems(type, selectedIds, allMaterialApprovedIds, false)
            this.restOrderObj.dialog = false
          },
          onCancel: () => {
            this.restOrderObj.dialog = false
          }
        }
      } else {
        this.checkIfInvoiceHasItems(type, selectedIds, allMaterialApprovedIds, false)
      }
    },
    checkIfInvoiceHasItems (type, invoiceIds, materialIds, createRestOrder) {
      if (invoiceIds && invoiceIds.length > 0) {
        this.$_executeApi('post', `/invoices/can_create_invoice_status/${this.orderId}`, invoiceIds)
          .then(response => {
            if (response) {
              const status = response.data
              if (status === this.INVOICE_OK) {
                if (type === 1) {
                  this.noApprovedRows = {
                    dialog: true,
                    loading: false,
                    onSuccess: () => {
                      this.noApprovedRows.loading = true
                      this.invoiceMaterials(invoiceIds, materialIds, createRestOrder)
                    },
                    onCancel: () => {
                      this.noApprovedRows.loading = false
                      this.noApprovedRows.dialog = false
                    }
                  }
                } else if (type === 2) {
                  this.invoiceMaterials(invoiceIds, materialIds, createRestOrder)
                } else if (type === 3) {
                  this.approvedNotApprovedRows = {
                    dialog: true,
                    loading: false,
                    onSuccess: () => {
                      this.approvedNotApprovedRows.loading = true
                      this.invoiceMaterials(invoiceIds, materialIds, createRestOrder)
                    },
                    onCancel: () => {
                      this.approvedNotApprovedRows.loading = false
                      this.approvedNotApprovedRows.dialog = false
                    }
                  }
                }
              } else if (status === this.INVOICE_HAS_NEGATIVE_TOTAL) {
                this.createCreditNote = {
                  dialog: true,
                  loading: false,
                  onSuccess: () => {
                    this.createCreditNote.loading = true
                    this.invoiceMaterials(invoiceIds, materialIds, createRestOrder, true)
                  },
                  onCancel: () => {
                    this.createCreditNote.loading = false
                    this.createCreditNote.dialog = false
                  }
                }
              } else if (status === this.INVOICE_DRAFT) {
                this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.invoice.draftExists') })
              } else if (status === this.INVOICE_COMPLETED) {
                this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.invoice.allInvoiced') })
              } else {
                this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.invoice.noItemsOnInvoice') })
              }
            } else {
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.invoice.noItemsOnInvoice') })
            }
          })
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.invoice.noItemsOnInvoice') })
      }
    },
    invoiceMaterials (invoiceids, materialids, createRestOrder, iscreditnote = false) {
      var model = { invoiceids, materialids, iscreditnote }
      this.$_executeApi('post', `invoices/create_invoice_from_order/${this.orderId}/${createRestOrder}`, model)
        .then((response) => {
          if (response.data) {
            this.isAllSelected = false
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
            if (iscreditnote) {
              this.$router.push(`/orders/edit/${this.orderId}/invoice/creditnote/${response.data.id}?materials=true`)
            } else {
              this.$router.push(`/orders/edit/${this.orderId}/invoice/actions/${response.data.id}`)
            }
          }
        })
        .finally(() => {
          this.createCreditNote.loading = false
        })
    },
    getExchangeRate (currencyId) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `currencies/get_exchange_rate/${currencyId}`)
          .then((result) => {
            this.exchangeRate = result.data
            resolve(result)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    async recalculateExchangeRate (currencyId) {
      if (currencyId) {
        let previousRate = 0
        const oldRateResult = await this.updateCurrencyOnOrderAndGetRate(currencyId)
        if (oldRateResult && oldRateResult.data) {
          previousRate = oldRateResult.data
        }
        this.getExchangeRate(currencyId)
          .then((response) => {
            if (response.data) {
              const exchangeRate = response.data
              let totalSalesPrice = 0
              let totalPrice = 0
              const materials = this.$formatter.cloneVariable(this.listOfMaterials)
              materials.map(x => {
                if (!x.ispackage && !x.orderindex && x.productid) {
                  let getSalePrice = +this.$formatter.replaceCommaWithDot(x.price || 0)
                  let getCostPrice = +this.$formatter.replaceCommaWithDot(x.costprice || 0)
                  // let getPurchasePrice = +this.$formatter.replaceCommaWithDot(x.purchaseprice || 0)
                  let calculatedSales = previousRate ? getSalePrice * previousRate : getSalePrice
                  let calculatedCost = previousRate ? getCostPrice * previousRate : getCostPrice
                  // let calculatedPurchase = previousRate ? getPurchasePrice * previousRate : getPurchasePrice
                  let getDiscount = this.$formatter.replaceCommaWithDot(x.discount || 0)
                  x.price = (calculatedSales / exchangeRate).toFixed(2)
                  x.costprice = (calculatedCost / exchangeRate).toFixed(2)
                  // x.purchaseprice = (calculatedPurchase / exchangeRate).toFixed(2)
                  let qtyField = this.orderModel.type === 'offer' ? 'qty' : 'invoiceqty'
                  const qtyValue = this.$formatter.replaceCommaWithDot(x[qtyField] || 0)
                  x.total = qtyValue * +x.price
                  if (getDiscount) {
                    let rbtValue = (x.total * getDiscount) / 100
                    x.total = x.total - rbtValue
                  }
                  x.dg = this.dgCalculationFormula(+x.costprice, +x.price, getDiscount)
                  totalPrice += parseFloat(qtyValue * x.costprice)
                  totalSalesPrice += parseFloat(x.total)
                  x.price = this.$formatter.replaceDotWithComma(x.price || 0)
                  x.costprice = this.$formatter.replaceDotWithComma(x.costprice || 0)
                  // x.purchaseprice = this.$formatter.replaceDotWithComma(x.purchaseprice || 0)
                  x.total = this.$formatter.replaceDotWithComma(x.total || 0)
                  x.dg = this.$formatter.replaceDotWithComma(x.dg || 0)
                  return x
                }
              })
              this.grandCostTotal = parseFloat(totalPrice.toFixed(2))
              totalSalesPrice = parseFloat(totalSalesPrice.toFixed(2))
              this.grandTotal = parseFloat(totalSalesPrice)
              const dg = this.dgCalculationFormula(totalPrice, totalSalesPrice)
              this.totalDG = isNaN(dg) ? 0 : dg
              this.listOfMaterials = materials
              materials.map(x => {
                if (x.packageid) {
                  let getPackageIndex = this.listOfMaterials.findIndex(y => y.id === x.packageid)
                  if (getPackageIndex > -1) this.calculateParentData(getPackageIndex, x.packageid)
                }
              })
            }
          })
      }
    },
    downloadLabels () {
      this.actionLoading = true
      this.$_executeApi('post', `orders/print_labels/${this.orderId}`)
        .then((response) => {
          let fileName = response.data
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        })
        .finally(() => {
          this.actionLoading = false
        })
    },
    purchaseHandler () {
      this.purchaseModelObj = {
        dialog: true,
        onAllProduct: () => {
          this.allLoading = true
          this.createSupplierOrder()
        },
        onCancel: () => {
          this.purchaseModelObj.dialog = false
        }
      }
    },
    createSupplierOrder () {
      const listOfSupplierOrderMaterials = this.listOfMaterials.filter(x => x.includeonpurchaseorder) || []
      const suppliersSelected = listOfSupplierOrderMaterials.filter(x => x.product_issupplieronorder) || []
      const isSupplierNotSelected = suppliersSelected.some(x => !x.supplierid)
      if (isSupplierNotSelected) {
        // show dialog
        this.allLoading = false
        this.purchaseModelObj.dialog = false
        this.supplierNotSelected = {
          dialog: true,
          loading: false,
          onSuccess: () => {
            this.supplierNotSelected.loading = true
            this.createSupplierOrderHandler(listOfSupplierOrderMaterials)
          },
          onCancel: () => {
            this.supplierNotSelected.dialog = false
            this.supplierNotSelected.loading = false
          }
        }
      } else {
        this.createSupplierOrderHandler(listOfSupplierOrderMaterials)
      }
    },
    createSupplierOrderHandler (materials) {
      const purchaseIds = materials.filter(x => !x.product_notinventoryitem).map(x => x.id)
      this.$_executeApi('post', `warehouseorderitems/create_order_from_material/${this.orderId}`, purchaseIds)
        .then((response) => {
          if (response && response.data) {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.actionPerformed') })
            this.getOrderMaterials()
          } else {
            this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.invoice.noItemsOnOrder') })
          }
          this.supplierNotSelected.dialog = false
          this.supplierNotSelected.loading = false
        })
        .finally(() => {
          this.supplierNotSelected.loading = false
          this.purchaseModelObj.dialog = false
          this.allLoading = false
        })
    },
    filterItemsByStatus (isFilter = false) {
      var splittedItemsParent = []
      // var splittedItemsPackage = []
      // var splittedItemsMainPackage = []
      this.listOfMaterials.map(x => {
        x.is_show = false
        let qty = +this.$formatter.replaceCommaWithDot(x.qty)
        if (this.productFilter === 1) x.is_show = true
        else if (this.productFilter === 2) {
          if (x.available >= qty || x.ispackage) {
            x.is_show = true
          }
        } else if (this.productFilter === 3) {
          if (x.available < qty) {
            x.is_show = true
          }
        } else if (this.productFilter === 4) {
          let pickedqty = +this.$formatter.replaceCommaWithDot(x.pickedqty)
          if (pickedqty > 0 || x.ispackage) {
            x.is_show = true
          }
        } else if (this.productFilter === 5) { // to be picked
          let pickedqty = +this.$formatter.replaceCommaWithDot(x.pickedqty)
          if (!pickedqty && !x.product_notinventoryitem && !x.isinformation) {
            if (x.orderindex) {
              splittedItemsParent.push(x.orderindex)
            }
            if (x.packageid) {
              // splittedItemsPackage.push(x.packageid)
              // if (!x.content_show) x.content_show = true
            } else if (x.mainpackageid) {
              // splittedItemsMainPackage.push(x.mainpackageid)
              // if (!x.content_show) {
              //   x.toggle_show = true
              //   x.content_show = true
              // }
            }
            x.is_show = true
          }
        } else if (this.productFilter === 6) { // order created - show materials where ordermaterialid is set
          if (x.ordermaterialid) {
            x.is_show = true
          }
        } else if (this.productFilter === 7) { // no order - show materials where ordermaterialid is not set
          if (!x.ordermaterialid) {
            x.is_show = true
          }
        }
        return x
      })
      if (this.productFilter === 5) { // to be picked
        this.listOfMaterials.map(x => {
          if (splittedItemsParent.includes(x.id)) x.is_show = true
          return x
        })
      }

      // After applying status filter, also apply product search filters if active
      const hasProductNumberSearch = this.productSearchText && this.productSearchText.trim()
      const hasProductNameSearch = this.productNameSearchText && this.productNameSearchText.trim()

      if (hasProductNumberSearch || hasProductNameSearch) {
        this.applyCombinedProductFilters()
      }
      // else if (this.productFilter === 1 && isFilter) { // all
      //   this.getOrderMaterials()
      // }
    },
    getFutureWeeks () {
      let weeks = []
      let currentWeek = moment().isoWeek()
      let activeWeek = `${currentWeek}/${moment().isoWeekYear()}`
      weeks.push({
        text: activeWeek,
        value: activeWeek
      })
      for (let i = 1; i <= 10; i++) {
        let futureWeek = moment().add(i, 'isoweeks')
        var value = `${futureWeek.format('WW/GGGG')}`
        weeks.push({
          text: value,
          value: value
        })
      }
      return weeks
    },
    async toggleContentProducts (packageId, index, isCollapsed) {
      return new Promise(async (resolve) => {
        this.loadingProducts = true
        // check if already contents are loaded
        const draggedId = this.draggingRowItem ? this.draggingRowItem.id : 0
        const alreadyLoaded = this.listOfMaterials.some(x => x.packageid === packageId || x.mainpackageid === packageId)
        this.listOfMaterials.map(x => {
          if (x.packageid === packageId || x.mainpackageid === packageId) x.zonefilter = true
          return x
        })
        if (!alreadyLoaded || packageId === draggedId) {
          const childData = await this.getSubContents(packageId)
          let materials = []
          if (packageId === draggedId) {
            materials = this.listOfMaterials.filter(x => x.packageid !== packageId && x.mainpackageid !== packageId && x.productid)
          } else {
            materials = this.listOfMaterials.filter(x => x.productid)
          }
          materials.splice(index + 1, 0, ...childData)
          setTimeout(() => {
            this.listOfMaterials = materials
            this.addAdditionalRowForNew()
            resolve(this.listOfMaterials)
            this.filterItemsByStatus()
          })
        } else resolve(this.listOfMaterials)
        setTimeout(() => {
          const mainParent = this.listOfMaterials.find(x => x.id === packageId && !x.mainpackageid)
          this.subContentsToggle(packageId, isCollapsed, mainParent)
          var getObj = this.$formatter.cloneVariable(this.listOfMaterials[index])
          getObj.toggle_show = !getObj.toggle_show
          this.$set(this.listOfMaterials, index, getObj)
          this.loadingProducts = false
        }, 50)
      })
    },
    async getSubContents (id) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `ordermaterials/get_child_materials_list/${this.orderId}/${id}`)
          .then(async (response) => {
            if (response.data) {
              const list = response.data
              list.map(async x => {
                x.qty = this.$formatter.replaceDotWithComma(x.qty)
                x.pickedqty = this.$formatter.replaceDotWithComma(x.pickedqty)
                x.invoiceqty = this.$formatter.replaceDotWithComma(x.invoiceqty)
                x.price = this.$formatter.replaceDotWithComma(x.price)
                x.costprice = this.$formatter.replaceDotWithComma(x.costprice)
                x.purchaseprice = this.$formatter.replaceDotWithComma(x.purchaseprice)
                x.discount = this.$formatter.replaceDotWithComma(x.discount)
                x.total = this.$formatter.replaceDotWithComma(x.total)
                x.dg = this.$formatter.replaceDotWithComma(x.dg)
                x.netweight = this.$formatter.replaceDotWithComma(x.netweight)
                x.grossweight = this.$formatter.replaceDotWithComma(x.grossweight)
                if (!this.isNothingPicked) {
                  this.isNothingPicked = +this.$formatter.replaceCommaWithDot(x.pickedqty) > 0
                }
                x.is_show = true
                x.toggle_show = false
                x.content_show = true
                x.zonefilter = true
                if (x.invoice_id && !this.isInvoiced) this.isInvoiced = true
                x.olditem = this.$formatter.cloneVariable(x)
                x.real_sales_price = x.price
                x.real_cost_price = x.costprice
                x.isbatch = x.product_batchrequired
                x.isopenstructure = x.product_openstructure
                if (x.isfreight) {
                  x.producttext = 'Frakt'
                  x.number = '1000'
                }
                // get warehouse
                let warehouses = []
                if (!this.isOffer) {
                  this.loadingWarehouse = true
                  warehouses = await this.getWarehouseStockHandler(x.productid)
                  this.loadingWarehouse = false
                }
                x.warehouses = warehouses
                // get available items
                this.loadingSupplier = true
                let availableObj = this.totalAvailableItems.find(y => y.productid === x.productid)
                x.available = availableObj ? availableObj.available : 0
                this.loadingSupplier = false

                // set suppliers
                if (x.productid && x.product_issupplieronorder && x.supplierid) {
                  x.suppliers = [{ id: x.supplierid, name: x.customer_name }]
                }

                // check qty greater than available if is it OFFER
                if (this.isOffer) {
                  const qty = +this.$formatter.replaceCommaWithDot(x['qty'] || 0)
                  const available = +this.$formatter.replaceCommaWithDot(x['available'] || 0)
                  if (qty > available) {
                    x.qtyTrue = true
                  } else x.qtyTrue = false
                }
                return x
              })
              resolve(list)
            } else resolve([])
          })
      })
    },
    subContentsToggle (packageId, isCollapsed, isParent) {
      this.listOfMaterials.map(x => {
        if (x.packageid === packageId || packageId === x.mainpackageid) {
          x.content_show = !isCollapsed
          if (!x.content_show) {
            x.toggle_show = !isCollapsed
          }
        }
        if (isParent && isCollapsed && packageId === x.mainpackageid) this.subContentsToggle(x.id, isCollapsed)
        return x
      })
    },
    subContentsCollapse (packageId, isParent) {
      this.listOfMaterials.map(x => {
        if (x.packageid === packageId || packageId === x.mainpackageid) {
          x.content_show = false
          if (!x.content_show) {
            x.toggle_show = false
          }
        }
        if (isParent && packageId === x.mainpackageid) this.subContentsCollapse(x.id)
        return x
      })
    },
    toggleAllPackages (expand = false) {
      return new Promise((resolve) => {
        // Use nextTick for better Vue reactivity handling
        this.$nextTick(() => {
          this.listOfMaterials.forEach(x => {
            if (x.packageid) this.subContentsCollapse(x.packageid)
          })
          this.listOfMaterials.forEach(x => {
            if (x.ispackage) x.toggle_show = expand
          })
          resolve()
        })
      })
    },
    getRandomColor () {
      var letters = 'BCDEF'.split('')
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * letters.length)]
      }
      return `${color}4a`
    },
    generateRandomNumber () {
      var r = Math.floor(Math.random() * 100) + 1
      if (this.addedRandomNumbers.indexOf(r) === -1) {
        this.addedRandomNumbers.push(r)
        return r
      }
    },
    checkForImport () {
      if (this.orderModel.archicadimportcount >= 1) {
        this.warningDialog = true
      } else {
        this.importDialog = true
        this.importFile = []
      }
    },
    importFileHandler () {
      let file = this.importFile
      var formData = new FormData()
      formData.append(file.name, file)
      this.loader = true
      this.$_executeApi('post', `ordermaterials/import_archicad_data?orderId=${this.orderId}`, formData)
        .then(response => {
          const results = response.data
          if (results) {
            if (results.allwentok) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.importSuccess') })
              this.getSingleRecordHandler()
            } else {
              this.errorImportDialog = true
              this.errorStatusImport = results.errors
            }
            this.importFile = []
            this.$refs.importForm.reset()
            this.importDialog = false
          }
        }).finally(() => {
          this.loader = false
        })
    },
    updateCurrencyOnOrder (id) {
      let model = { invoicecurrencyid: id }
      return this.$_executeApi('put', `orders/${this.orderId}`, model)
    },
    updateCurrencyOnOrderAndGetRate (id) {
      let model = { invoicecurrencyid: id }
      return this.$_executeApi('post', `orders/updatecurrecny_getexchangerate/${this.orderId}`, model)
    },
    checkQtyWithStock ({ pickedqty, warehouses }) {
      pickedqty = +this.$formatter.replaceCommaWithDot(pickedqty) || 0
      warehouses = warehouses || []
      let totalStock = this.$_getSum(warehouses.map(x => +x.onstock))
      let obj = {}
      if (warehouses && warehouses.length === 1 && warehouses[0].onstock >= pickedqty) obj.warehouseid = warehouses[0].warehouse_id
      obj.outofstock = pickedqty ? pickedqty > totalStock : false
      return obj
    },
    checkWarehouseStock (index, item) { // It is for checking warehouse stock and set the flag
      if (this.isOrder && (item.isproduction ? (!this.orderModel.isproductionorder || !item.ispackage) : !item.ispackage) && !item.olditem.pickedqty) {
        let { outofstock, warehouseid } = this.checkQtyWithStock(item)
        item.warehouseOutOfStock = outofstock
        if (warehouseid) item.warehouseid = warehouseid
        this.$set(this.listOfMaterials, index, item)
        setTimeout(() => {
          this.checkIfCCSheetIsOpen(index)
            .then((result) => {
              if (!result) {
                if (warehouseid) this.getListOfLocations(index)
              }
            })
        })
      }
      /* let isProduct = !material.ispackage
      if (isProduct) {
        let splittedRows = this.listOfMaterials.filter(z => z.orderindex === material.id)
        const length = splittedRows.length || 0
        index = index + length
      }
      const qty = +this.$formatter.replaceCommaWithDot(material.qty) || 0
      let warehouseListMaterial = this.listOfMaterials[index]
      let warehouses = warehouseListMaterial.warehouses || []
      let totalStock = this.$_getSum(warehouses.map(x => +x.onstock)) */
      // warehouseListMaterial.warehouseOutOfStock = qty ? qty > totalStock : false
      // this.$set(this.listOfMaterials, index, this.listOfMaterials[index])
    },
    getWarehouseLocations (term, index, event, warehouseid) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      if (searchText !== null) {
        let query = {
          select: ['id', 'name', 'warehouseid', 'isdefault'],
          additionalfilters: [`name contains  '${searchText}'`],
          skip: 0,
          limit: 50,
          filter: `isactive eq 1 and warehouseid eq ${warehouseid}`,
          'order_by': {
            'field': 'name',
            'asc_or_desc': 'asc'
          }
        }
        this.$set(this.listOfPackageForStock, index, { ...this.listOfPackageForStock[index], locationLoading: true })
        this.$_executeApi('post', 'warehouselocations/query', query).then((response) => {
          let currentItem = this.listOfPackageForStock[index]
          currentItem.listOfLocation = response.data
          this.$set(this.listOfPackageForStock, index, currentItem)
        }).finally(() => {
          this.$set(this.listOfPackageForStock, index, { ...this.listOfPackageForStock[index], locationLoading: false })
        })
      }
    },
    setSupplierName (index, supplierId) {
      const supplierObj = this.listOfMaterials[index].suppliers ? this.listOfMaterials[index].suppliers.find(x => x.id === supplierId) : {}
      if (supplierObj) {
        this.$set(this.listOfMaterials, index, { ...this.listOfMaterials[index], customer_name: supplierObj.name })
      }
    },
    // Searching suppliers
    loadSuppliers (term, index, event) {
      if ([32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      let model = {
        'filter': `name contains '${searchText}'`,
        'additionalfilters': [`isactive eq 1 AND issupplier eq 1`],
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        },
        'skip': 0,
        'limit': 50
      }
      this.$_executeApi('post', 'customers/query', model)
        .then((response) => {
          if (!this.listOfMaterials[index].suppliers) this.listOfMaterials[index].suppliers = []
          this.$set(this.listOfMaterials, index, { ...this.listOfMaterials[index], suppliers: response.data })
        })
    },
    toggleLocations (index, action, locationid) {
      let items = this.$formatter.cloneVariable(this.listOfPackageForStock)
      if (action === this.HIDE && items[index] && items[index].listOfLocation) {
        let locations = items[index].listOfLocation.filter(x => x.id === locationid)
        items[index].listOfLocation = locations
      }
      if (this.listOfPackageForStock && this.listOfPackageForStock.length > 0 && this.listOfPackageForStock[index]) this.$set(this.listOfPackageForStock, index, items[index])
    },
    checkEditable (event, index) {
      const element = this.listOfMaterials[index]
      if (element.isedit) event.stopPropagation()
    },
    openDiscountDialog () {
      this.discountObj = {
        dialog: true,
        discount: '',
        loading: false,
        onSuccess: () => {
          if (this.$refs.discountValidation.validate()) {
            this.discountObj.loading = true
            this.$_executeApi('post', `ordermaterials/update_discount/${this.orderId}?discount=${this.discountObj.discount || 0}`)
              .then((response) => {
                this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updateMsg') })
                this.getOrderMaterials()
                this.discountObj.dialog = false
              })
              .finally(() => {
                this.discountObj.loading = false
              })
          } else {
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
          }
        },
        onClose: () => {
          this.discountObj.dialog = false
        }
      }
    },
    async loadStockedLocation (index, warehouseid, productid) {
      let currentItem = this.listOfPackageForStock[index]
      this.$set(this.listOfPackageForStock, index, { ...currentItem, locationLoading: true })
      this.getStockHandler(warehouseid, productid)
        .then((response) => {
          if (!this.listOfPackageForStock[index].listOfLocation) this.listOfPackageForStock[index].listOfLocation = []
          currentItem.listOfLocation = response
          currentItem.locationid = 0
          currentItem.locationLoading = false
          this.$set(this.listOfPackageForStock, index, currentItem)
        })
    },
    mainActionHandler (action) {
      switch (action) {
        case 'import':
          this.checkForImport()
          break
        case 'purchase':
          this.purchaseHandler()
          break
        case 'pick':
          this.autoPickHandler()
          break
        case 'print':
          this.downloadLabels()
          break
        case 'export':
          this.exportMaterials()
          break
      }
    },
    exportMaterials () {
      this.actionLoading = true

      // Check if any filter or search is active
      const hasStatusFilter = this.productFilter !== 1 // 1 is "All"
      const hasProductNumberSearch = this.productSearchText && this.productSearchText.trim()
      const hasProductNameSearch = this.productNameSearchText && this.productNameSearchText.trim()
      const hasAnyFilter = hasStatusFilter || hasProductNumberSearch || hasProductNameSearch

      // If filters/searches are active, collect IDs of visible materials
      let payload = null
      if (hasAnyFilter) {
        // Get IDs of all visible materials (is_show = true)
        const visibleMaterialIds = this.listOfMaterials
          .filter(x => x.is_show && x.id && (x.productid || x.isfreight))
          .map(x => x.id)

        if (visibleMaterialIds.length === 0) {
          this.actionLoading = false
          this.$root.$emit('snackbar', { snackbar: true, color: 'warning', text: this.$t('message.common.noResults') })
          return
        }

        payload = visibleMaterialIds
      }

      // Call API with or without filtered IDs
      const apiCall = this.$_executeApi('post', `ordermaterials/export_materials/${this.orderId}`, { ids: payload || [] })
      apiCall.then((response) => {
        this.$_downloadExportedReport(response.data).then(() => { this.actionLoading = false })
      })
    },
    autoPickHandler () {
      this.actionLoading = true
      this.$_executeApi('get', `ordermaterials/auto_pick_materials/${this.orderId}`)
        .then((response) => {
          if (response.data) {
            var materials = response.data
            materials.map(x => {
              const materialIndex = this.listOfMaterials.findIndex(y => y.id === x.id)
              if (materialIndex !== -1) {
                const materialObj = this.$formatter.cloneVariable(this.listOfMaterials[materialIndex])
                materialObj.pickedqty = materialObj.qty
                materialObj.warehouseid = x.warehouseid
                materialObj.locationid = x.locationid
                this.$set(this.listOfMaterials, materialIndex, materialObj)
              }
            })
            if (materials && materials.length === 0) {
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.noProductsFoundForPicking') })
            } else {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.order.productsPickedSuccessfully', { count: materials.length }) })
              this.lastExpandedView = this.listOfMaterials.filter(x => x.toggle_show && !x.packageid).map(x => x.id) || []
              this.loadingProducts = true
              this.getOrderMaterials()
                .then(() => {
                  this.saveMaterials(false, false)
                })
            }
          }
          this.actionLoading = false
        })
        .catch(() => {
          this.actionLoading = false
        })
    },
    undoPicking (item) {
      if (item.id) {
        this.undoPick = {
          dialog: true,
          loading: false,
          material: item || {},
          onSuccess: () => {
            this.reserveTheStockOfProduct(item)
          },
          onClose: () => {
            this.undoPick.dialog = false
            this.undoPick.material = {}
          }
        }
      }
    },
    reserveTheStockOfProduct (item) {
      this.undoPick.loading = true
      this.$_executeApi('post', 'ordermaterials/undo_picked_product', { ids: [item.id] })
        .then((response) => {
          if (response && response.data) {
            this.undoPick.loading = false
            this.undoPick.dialog = false
            this.undoPick.material = {}
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.order.stockRevered') })
            this.getOrderMaterials()
          }
        })
    },
    onScroll () {
      if (window.pageYOffset <= 0) this.showScrollToTop = false
      else this.showScrollToTop = true
      setTimeout(() => {
        this.onResize()
      })
    },
    onResize () {
      this.showScrollToBottom = window.innerWidth > document.documentElement.clientWidth
    },
    scrollToTop () {
      goTo(0)
    },
    goToBottom () {
      goTo(this.pageHeight)
    },
    handleProductSearchBlur () {
      // Hide search field only if no search text is entered
      if (!this.productSearchText || this.productSearchText.trim() === '') {
        this.showProductSearch = false
      }
    },
    async filterByProductNumber () {
      // Clear any existing debounce timer
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
      }

      const searchText = (this.productSearchText || '').toLowerCase().trim()

      if (!searchText) {
        // If search is empty, reset immediately without delay
        this.filterItemsByStatus(false)
        return
      }

      // Add 500ms delay before triggering search
      this.searchDebounceTimer = setTimeout(async () => {
        // Step 1: First apply status filter to get base visibility
        this.loadingProducts = true
        await this.toggleAllPackages(false)
        this.loadingProducts = false
        this.filterItemsByStatus(false)
      }, 500)
    },
    applyCombinedProductFilters () {
      const numberSearchText = (this.productSearchText || '').toLowerCase().trim()
      const nameSearchText = (this.productNameSearchText || '').toLowerCase().trim()

      // Performance optimization: Use a Set to track items to show
      const productMatchIds = new Set()
      const parentPackagesToExpand = new Set() // Only packages that need to be expanded
      const parentPackagesToShow = new Set() // All packages in the hierarchy to show

      // First pass: Find all items matching BOTH search criteria (if both are active)
      // Search ALL items to find deeply nested products, regardless of status filter
      for (let i = 0; i < this.listOfMaterials.length; i++) {
        const item = this.listOfMaterials[i]

        // Check if this item matches the search criteria
        let matchesNumber = !numberSearchText || (item.number && item.number.toLowerCase().includes(numberSearchText))
        let matchesName = !nameSearchText || (item.producttext && item.producttext.toLowerCase().includes(nameSearchText))

        // Item must match BOTH searches if both are active (AND logic)
        if (matchesNumber && matchesName) {
          productMatchIds.add(item.id)

          // Only expand parent packages if this is NOT a package itself
          // If a package matches, we show it but don't force-expand it
          if (!item.ispackage) {
            // This is a regular product, so we need to expand parents to show it
            if (item.packageid) {
              this.markParentPackagesForShow(item.packageid, parentPackagesToShow, parentPackagesToExpand, true)
            }
            if (item.mainpackageid) {
              this.markParentPackagesForShow(item.mainpackageid, parentPackagesToShow, parentPackagesToExpand, true)
            }
          } else {
            // This is a package that matches - show it but don't expand it
            // We still need to show parent packages (but not expand them either)
            if (item.packageid) {
              this.markParentPackagesForShow(item.packageid, parentPackagesToShow, parentPackagesToExpand, false)
            }
            if (item.mainpackageid) {
              this.markParentPackagesForShow(item.mainpackageid, parentPackagesToShow, parentPackagesToExpand, false)
            }
          }
        }
      }

      // Second pass: Update is_show to only show matches and their parents
      // IMPORTANT: Only hide items that don't match search, but keep status filter respected
      for (let i = 0; i < this.listOfMaterials.length; i++) {
        const item = this.listOfMaterials[i]

        // Show item if:
        // 1. It matches the product search(es) AND passes status filter
        // 2. It's a parent package of a matching item (override status filter for hierarchy)
        const matchesSearch = productMatchIds.has(item.id) || parentPackagesToShow.has(item.id)

        // If item doesn't match search, hide it (respecting the product search filter)
        // If item matches search, keep its current is_show state from status filter
        // UNLESS it's a parent package - then we must show it to display the hierarchy
        const shouldShow = matchesSearch && (item.is_show || parentPackagesToShow.has(item.id))

        if (shouldShow !== item.is_show) {
          this.$set(this.listOfMaterials[i], 'is_show', shouldShow)
        }
      }
    },
    applyProductNumberFilter () {
      // This method is kept for backward compatibility
      // It now calls the combined filter method
      this.applyCombinedProductFilters()
    },
    handleProductNameSearchBlur () {
      // Hide search field only if no search text is entered
      if (!this.productNameSearchText || this.productNameSearchText.trim() === '') {
        this.showProductNameSearch = false
      }
    },
    async filterByProductName () {
      // Clear any existing debounce timer
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
      }

      const searchText = (this.productNameSearchText || '').toLowerCase().trim()

      if (!searchText) {
        // If search is empty, reset immediately without delay
        this.filterItemsByStatus(false)
        return
      }

      // Add 300ms delay before triggering search
      this.searchDebounceTimer = setTimeout(async () => {
        // Step 1: First apply status filter to get base visibility
        this.loadingProducts = true
        await this.toggleAllPackages(false)
        this.loadingProducts = false
        this.filterItemsByStatus(false)
      }, 500)
    },
    applyProductNameFilter () {
      // This method is kept for backward compatibility
      // It now calls the combined filter method
      this.applyCombinedProductFilters()
    },
    markParentPackagesForShow (packageId, parentShowSet, parentExpandSet, shouldExpand) {
      if (!packageId) return

      parentShowSet.add(packageId)

      // Only add to expand set if we should expand parents
      if (shouldExpand) {
        parentExpandSet.add(packageId)
      }

      // Find the parent item and recursively mark its parents
      const parentIndex = this.listOfMaterials.findIndex(x => x.id === packageId)
      if (parentIndex !== -1) {
        const parentItem = this.listOfMaterials[parentIndex]

        // Recursively mark grandparents (with same expand behavior)
        if (parentItem.packageid) {
          this.markParentPackagesForShow(parentItem.packageid, parentShowSet, parentExpandSet, shouldExpand)
        }
        if (parentItem.mainpackageid) {
          this.markParentPackagesForShow(parentItem.mainpackageid, parentShowSet, parentExpandSet, shouldExpand)
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    // Clear debounce timer to prevent memory leaks
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer)
      this.searchDebounceTimer = null
    }

    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('downloadComplete')
  }
}
</script>
<style>
.material-table .v-data-table th {
  padding: 0 1px !important;
}
.materials .v-text-field.v-text-field--enclosed .v-text-field__details, .materials .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  padding: 0 4px !important;
}
.text-right-align input, .text-right-align select {
  text-align: right !important;
}
.material-table .v-input {
  font-size: 14px !important;
}
.material-table .v-textarea.v-text-field--enclosed.v-text-field--outlined textarea {
  margin-top: 2px !important;
}
.material-table .v-textarea textarea {
  padding: 2px 0 1px !important;
}
.material-table .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 30px !important;
}
.material-table .v-input--selection-controls .v-input--selection-controls__input {
  margin-right: 0px !important;
}
.material-table .v-select__slot {
  height: 30px !important;
}
.material-table .v-input__append-inner {
  margin-top: 4px !important;
}
.material-table .v-btn--fab.v-size--small {
  height: 33px !important
}
.material-table .v-data-table__wrapper {
  overflow-x: hidden !important;
}
/* Performance optimizations for smoother scrolling */
.material-table tbody tr {
  will-change: transform;
  contain: layout style paint;
}
.material-table tbody td {
  contain: layout style;
}
/* Static row background colors - CRITICAL PERFORMANCE FIX */
.row-package-bg {
  background-color: rgba(189, 236, 235, 0.29) !important;
}
.row-stock-item-bg {
  background-color: #00800026 !important;
}
.row-non-stock-item-bg {
  background-color: #450eec26 !important;
}
/* Order warehouse Show Available */
.custom_prepend_icon > div.v-input__prepend-outer {
  margin: 0 !important;
  padding: 1px;
  margin-top: 1.5px !important;
  /* position: absolute; */
  /* z-index: 6; */
}
.custom_prepend_icon > div.v-input__prepend-outer > div.v-input__icon--prepend {
  width: 10px;
  height: 10px;
  min-width: 10px;
}
.custom_prepend_icon > div.v-input__prepend-outer > div.v-input__icon--prepend button.v-icon {
  font-size: 14px !important;
}
.out_of_stock div.v-input__icon--prepend > button.v-icon {
  color: #cd5c5c !important;
}
.package_item_table .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  font-size: 14px;
  padding: 0 4px !important;
}
.package_item_table .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 35px !important;
}
.material-loading {
  display: block;
  width: 100px;
  margin: 0 auto;
  left: 50%;
  top: 50%;
  position: fixed;
}
.margin-2px {
  margin-top: 2px;
}
.additional-row label {
  font-size: 12px;
  margin-left: 6px;
}
</style>
